webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(335)
}
var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(409),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "find", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findAll", function() { return findAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "update", function() { return update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "create", function() { return create; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remove", function() { return remove; });
var BaseService = __webpack_require__(6);

var namespace = 'reservations';

var find = function find(id, options, cb) {
  BaseService.get(namespace + '/' + id, options, cb);
};

var findAll = function findAll(options, cb) {
  BaseService.get(namespace, options, cb);
};

var update = function update(id, options, cb, errorCb) {
  BaseService.put(namespace + '/' + id, options, cb, errorCb);
};

var create = function create(options, cb, errorCb) {
  BaseService.post(namespace, options, cb, errorCb);
};

var remove = function remove(id, cb, errorCb) {
  BaseService.remove(namespace + '/' + id, cb, errorCb);
};



/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remove", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "post", function() { return post; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "put", function() { return put; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(36);
var _this = this;





var VueInstance = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

var get = function get(path, data, _cb, errorCb) {
  VueInstance.$http.get(path, { params: data }).then(function (response) {
    _cb(response);
  }).catch(function (error) {
    var response = error.response;

    if (response && response.status) {
      if (response.status === 401 || response.status === 403) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('authRefreshToken', {
          cb: function cb() {
            _this.get(path, data, _cb, errorCb);
          }
        });
        return;
      }
    }

    if (!errorCb && error.response) {
      eventHub.$emit('ajax-error', error.response);
      return;
    }

    if (errorCb) {
      errorCb(error);
    }
  });
};

var remove = function remove(path, _cb2, errorCb) {
  VueInstance.$http.delete(path).then(function (response) {
    _cb2(response);
  }).catch(function (error) {
    var response = error.response;

    if (response && response.status) {
      if (response.status === 401 || response.status === 403) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('authRefreshToken', {
          cb: function cb() {
            _this.remove(path, _cb2, errorCb);
          }
        });
        return;
      }
    }

    if (!errorCb && error.response) {
      eventHub.$emit('ajax-error', error.response);
      return;
    }

    if (errorCb) {
      errorCb(error);
    }
  });
};

var post = function post(path, data, _cb3, errorCb) {
  VueInstance.$http.post(path, data).then(function (response) {
    _cb3(response);
  }).catch(function (error) {
    var response = error.response;

    if (response && response.status) {
      if (response.status === 401 || response.status === 403) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('authRefreshToken', {
          cb: function cb() {
            _this.post(path, data, _cb3, errorCb);
          }
        });
        return;
      }
    }

    if (!errorCb && error.response) {
      eventHub.$emit('ajax-error', error.response);
      return;
    }

    if (errorCb) {
      errorCb(error);
    }
  });
};

var put = function put(path, data, _cb4, errorCb) {
  VueInstance.$http.put(path, data).then(function (response) {
    _cb4(response);
  }).catch(function (error) {
    var response = error.response;

    if (response && response.status) {
      if (response.status === 401 || response.status === 403) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('authRefreshToken', {
          cb: function cb() {
            _this.put(path, data, _cb4, errorCb);
          }
        });
        return;
      }
    }

    if (!errorCb && error.response) {
      eventHub.$emit('ajax-error', error.response);
      return;
    }

    if (errorCb) {
      errorCb(error);
    }
  });
};



/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "find", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findAll", function() { return findAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "update", function() { return update; });
var BaseService = __webpack_require__(6);

var namespace = 'rooms';

var find = function find(id, options, cb) {
  BaseService.get(namespace + '/' + id, options, cb);
};

var findAll = function findAll(options, cb) {
  BaseService.get(namespace, options, cb);
};

var update = function update(id, options, cb) {
  BaseService.put(namespace + '/' + id, options, cb);
};



/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(329)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(402),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "find", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findAll", function() { return findAll; });
var BaseService = __webpack_require__(6);

var namespace = 'reservations/types';

var find = function find(id, options, cb) {
  BaseService.get(namespace + '/' + id, options, cb);
};

var findAll = function findAll(options, cb) {
  BaseService.get(namespace, options, cb);
};



/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(321)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(392),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3fdd1fc6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(331)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(404),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_auth__ = __webpack_require__(271);








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */].Store({
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
    getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
    modules: {
        auth: __WEBPACK_IMPORTED_MODULE_5__modules_auth__["a" /* default */]
    },
    strict: debug
}));

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "find", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findAll", function() { return findAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "update", function() { return update; });
var BaseService = __webpack_require__(6);

var namespace = 'products';

var find = function find(id, options, cb) {
  BaseService.get(namespace + '/' + id, options, cb);
};

var findAll = function findAll(options, cb) {
  BaseService.get(namespace, options, cb);
};

var update = function update(id, options, cb) {
  BaseService.put(namespace + '/' + id, options, cb);
};



/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(314)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(380),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "login", function() { return login; });
var BaseService = __webpack_require__(6);

var login = function login(email, password, cb, errorCb) {
  BaseService.post('login', { email: email, password: password }, cb, errorCb);
};



/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "find", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findAll", function() { return findAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "create", function() { return create; });
var BaseService = __webpack_require__(6);

var namespace = 'cleanings';

var find = function find(id, options, cb) {
  BaseService.get(namespace + '/' + id, options, cb);
};

var findAll = function findAll(options, cb) {
  BaseService.get(namespace, options, cb);
};

var create = function create(options, cb, errorCb) {
  BaseService.post(namespace, options, cb, errorCb);
};



/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "find", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findAll", function() { return findAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "update", function() { return update; });
var BaseService = __webpack_require__(6);

var namespace = 'hotel/meta';

var find = function find(id, options, cb) {
  BaseService.get(namespace + '/' + id, options, cb);
};

var findAll = function findAll(options, cb) {
  BaseService.get(namespace, options, cb);
};

var update = function update(id, options, cb) {
  BaseService.put(namespace + '/' + id, options, cb);
};



/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(315)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(382),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

/* unused harmony default export */ var _unused_webpack_default_export = (process);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(34)))

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('moneyFormat', function (value) {
    // Check if the value is numeric
    if (!(!isNaN(parseFloat(value)) && isFinite(value))) {
        return value;
    }

    var parts = value.toString().split("#");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join("#");
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('fixedNumber', function (value, decimals) {
    return parseFloat(value).toFixed(decimals);
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(36);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'home',
        component: __webpack_require__(363),
        meta: {
            access: 'all',
            layout: false
        }
    }, {
        path: '/reservations',
        name: 'reservations',
        component: __webpack_require__(373)
    }, {
        path: '/reservations/new',
        name: 'reservations.create',
        component: __webpack_require__(371)
    }, {
        path: '/reservations/grouped',
        name: 'reservations.grouped',
        component: __webpack_require__(372)
    }, {
        path: '/breakfasts',
        name: 'breakfasts',
        component: __webpack_require__(365)
    }, {
        path: '/cleaning',
        name: 'cleaning',
        component: __webpack_require__(366)
    }, {
        path: '/reporting',
        name: 'reporting',
        component: __webpack_require__(370)
    }, {
        path: '/reporting/daily',
        name: 'reporting.daily',
        component: __webpack_require__(369)
    }, {
        path: '/statistics',
        name: 'statistics',
        component: __webpack_require__(379)
    },

    // Products
    {
        path: '/products',
        name: 'products',
        component: __webpack_require__(367)
    }, {
        path: '/products/:id',
        name: 'products.view',
        component: __webpack_require__(368)
    },

    // Rooms
    {
        path: '/rooms',
        name: 'rooms',
        component: __webpack_require__(376)
    }, {
        path: '/rooms/available',
        name: 'rooms.available',
        component: __webpack_require__(375)
    }, {
        path: '/rooms/:id',
        name: 'rooms.view',
        component: __webpack_require__(377)
    }, {
        path: '/settings',
        name: 'settings',
        component: __webpack_require__(378)
    },

    // Reservations
    {
        path: '/reservations/:id',
        name: 'reservations.view',
        component: __webpack_require__(374)
    }, {
        path: '/login',
        name: 'login',
        component: __webpack_require__(364),
        meta: {
            access: 'all',
            layout: false
        }
    }]
});

// Security
router.beforeEach(function (to, from, next) {
    var identity = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.auth.identity;

    if (!identity && to.matched.length) {
        var match = to.matched[0];

        if (!match.meta.access || match.meta.access !== 'all') {
            var query = !identity ? { redirect: to.fullPath } : {};

            next({
                path: '/login',
                query: query
            });

            return;
        }
    }

    next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 208 */,
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */,
/* 211 */,
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(322)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(393),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//

window.videojs = __webpack_require__(199);
videojs = videojs.default || videojs;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'video-player',
  props: {
    options: {
      type: Object,
      required: true
    },
    start: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    playsinline: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    customEventName: {
      type: String,
      default: function _default() {
        return 'statechanged';
      }
    }
  },
  mounted: function mounted() {
    if (!this.player) {
      this.initialize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.player) {
      this.dispose();
    }
  },
  methods: {
    initialize: function initialize() {

      // init
      var self = this;
      this.player = null;

      // videojs options
      var videoOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        autoplay: false,
        controls: true,
        preload: 'auto',
        fluid: false,
        muted: false,
        width: '100%',
        height: '360',
        language: 'en',
        controlBar: {
          remainingTimeDisplay: false,
          playToggle: {},
          progressControl: {},
          fullscreenToggle: {},
          volumeMenuButton: {
            inline: false,
            vertical: true
          }
        },
        techOrder: ['html5'],
        plugins: {}
      }, this.options);

      // check sources
      /*
      if (!videoOptions.sources || !videoOptions.sources.length) {
        console.warn('Missing required option: "sources".')
        return false
      }
      */

      // ios fullscreen
      var playsinline = this.playsinline;
      if (playsinline) {
        this.$el.children[0].setAttribute('playsinline', playsinline);
        this.$el.children[0].setAttribute('webkit-playsinline', playsinline);
      }

      // emit event
      var emitPlayerState = function emitPlayerState(event, value) {
        if (event) {
          self.$emit(event, self.player);
        }
        if (value) {
          var values = {};
          values[event] = value;
          self.$emit(self.customEventName, values);
        }
      };

      // videoOptions
      // console.log(videoOptions)

      // avoid error "VIDEOJS: ERROR: Unable to find plugin: __ob__"
      if (videoOptions.plugins) {
        delete videoOptions.plugins.__ob__;
      }

      this.player = videojs(this.$el.children[0], videoOptions, function () {

        // player readied
        var _this = this;
        self.$emit('ready', self.player);

        // events
        var events = ['loadeddata', 'canplay', 'canplaythrough', 'play', 'pause', 'waiting', 'playing', 'ended', 'error'];
        for (var i = 0; i < events.length; i++) {
          (function (event) {
            _this.on(event, function () {
              emitPlayerState(event, true);
            });
          })(events[i]);
        }

        this.on('timeupdate', function () {
          emitPlayerState('timeupdate', this.currentTime());
        });
      });
    },
    dispose: function dispose() {
      if (this.player && videojs) {
        if (this.player.techName_ !== 'Flash') {
          this.player.pause && this.player.pause();
        }
        videojs(this.$el.children[0]).dispose();
        if (!this.$el.children.length) {
          var video = document.createElement('video');
          video.className = 'video-js';
          this.$el.appendChild(video);
        }
        this.player = null;
      }
    }
  },
  watch: {
    options: {
      deep: true,
      handler: function handler(options, oldOptions) {
        this.dispose();
        if (options && options.sources && options.sources.length) {
          this.initialize();
        }
      }
    }
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_search_Search__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_search_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_search_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_navigation_KeyNavigation__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_navigation_KeyNavigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_navigation_KeyNavigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_PageBackground__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_PageBackground___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_layout_PageBackground__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_reservations_Overlay__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_reservations_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_reservations_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(312);
__webpack_require__(313);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',

    data: function data() {
        return {
            layout: false
        };
    },


    watch: {
        '$route': function $route() {
            this.updateLayoutSettings();
        }
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])({
        identity: 'authGetIdentity'
    }), {
        role: function role() {
            if (!this.identity) {
                return false;
            }

            return this.identity.role;
        },
        isAdmin: function isAdmin() {
            return this.role === 'admin';
        },
        isCleaner: function isCleaner() {
            return this.role === 'admin';
        }
    }),

    mounted: function mounted() {
        this.updateLayoutSettings();
    },


    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])({
        signOut: 'authSignOut'
    }), {
        updateLayoutSettings: function updateLayoutSettings() {
            var layout = true;

            var $router = this.$root.$router;

            if ($router.currentRoute) {
                var currentRoute = $router.currentRoute;

                if (currentRoute.meta.hasOwnProperty('layout')) {
                    layout = currentRoute.meta.layout;
                }
            }

            this.layout = layout;
        }
    }),

    components: {
        Search: __WEBPACK_IMPORTED_MODULE_1__components_search_Search___default.a,
        KeyNavigation: __WEBPACK_IMPORTED_MODULE_2__components_navigation_KeyNavigation___default.a,
        PageBackground: __WEBPACK_IMPORTED_MODULE_3__components_layout_PageBackground___default.a,
        ReservationOverlay: __WEBPACK_IMPORTED_MODULE_4__components_reservations_Overlay___default.a
    }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        date: Object
    },

    computed: {
        daysInMonth: function daysInMonth() {
            if (!this.date) {
                return 0;
            }

            return this.date.daysInMonth();
        }
    },

    methods: {
        day: function day(num) {
            var date = moment(this.date);
            date.date(num);

            return date.format('dd');
        },
        isToday: function isToday(num) {
            var format = 'YYYY-MM-DD';

            var today = moment();
            var date = moment(this.date);
            date.date(num);

            return today.format(format) === date.format(format);
        }
    }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = __webpack_require__(0);

var ReservationService = __webpack_require__(3);
var CleaningService = __webpack_require__(58);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            start: null,
            end: null,
            today: moment(),
            reservations: [],
            matchedReservations: {},
            hovered: null,
            cleaning: null,
            hasLoadedCleaning: null
        };
    },


    props: {
        room: Object,
        date: Object,
        groupedInvoice: Boolean,
        groupedReservations: Object,
        selected: Boolean
    },

    computed: {
        daysInMonth: function daysInMonth() {
            if (!this.date) {
                return 0;
            }

            return this.date.daysInMonth();
        },
        currentMonth: function currentMonth() {
            return this.date.month() === this.today.month() && this.date.year() === this.today.year();
        },
        cleaningStatus: function cleaningStatus() {
            if (!this.hasLoadedCleaning) {
                return 'Loading...';
            }

            if (!this.cleaning) {
                return 'Not cleaned today';
            }

            var date = moment(this.cleaning.created.date);
            var today = moment();

            if (date.format('YYYY-MM-DD') !== today.format('YYYY-MM-DD')) {
                return 'Not cleaned today';
            }

            return 'Cleaned today by ' + this.cleaning.user.name;
        },
        isClean: function isClean() {
            if (!this.hasLoadedCleaning) {
                return null;
            }

            if (!this.cleaning) {
                return false;
            }

            var date = moment(this.cleaning.created.date);
            var today = moment();

            return date.format('YYYY-MM-DD') === today.format('YYYY-MM-DD');
        }
    },

    watch: {
        date: function date() {
            this.loadReservations();
        }
    },

    mounted: function mounted() {
        this.loadReservations();
        this.loadCleanings();

        eventHub.$on('room.cleaned', this.notifyOnCleaning);
        eventHub.$on('reservation.updated', this.reloadReservations);
    },
    destroyed: function destroyed() {
        eventHub.$off('room.cleaned', this.notifyOnCleaning);
        eventHub.$off('reservation.updated', this.reloadReservations);
    },


    methods: {
        select: function select(day) {
            if (this.matchedReservations[day]) {
                if (this.groupedInvoice) {
                    this.$emit('reservationsGroup', this.matchedReservations[day]);

                    return;
                }

                eventHub.$emit('reservations.overlay', this.matchedReservations[day].id);

                return;
            }
        },
        reloadReservations: function reloadReservations(payload) {
            if (!payload.room || payload.room !== this.room.id) {
                return;
            }

            this.loadReservations();
        },
        notifyOnCleaning: function notifyOnCleaning(payload) {
            if (payload.room !== this.room.id) {
                return;
            }

            this.loadCleanings();

            this.$toastr('success', this.room.title + ' has been cleaned', 'Notification');
        },


        /**
         * Is selected
         *
         * @param i
         * @returns {boolean}
         */
        isSelected: function isSelected(i) {
            return this.start <= i && this.end >= i;
        },


        /**
         * Load reservations
         */
        loadReservations: function loadReservations() {
            var _this = this;

            this.hasLoaded = false;
            this.matchedReservations = {};

            var options = {
                filter_groups: [{
                    filters: [{
                        key: 'belongsToMonth',
                        value: this.date.format('YYYY-MM'),
                        operator: 'eq'
                    }]
                }, {
                    filters: [{
                        key: 'room',
                        value: this.room.id,
                        operator: 'eq'
                    }]
                }]
            };

            ReservationService.findAll(options, function (response) {
                var data = response.data;

                _this.reservations = data.rows;
                _this.hasLoaded = true;

                for (var i = 0; i < _this.daysInMonth; i++) {
                    var day = i + 1;

                    _this.$set(_this.matchedReservations, day, _this.reservation(day));
                }

                _this.$emit('reservationsLoaded');
            });
        },
        reservation: function reservation(i) {
            var date = moment(this.date.format('YYYY-MM') + '-' + i, "YYYY-MM-DD");

            var filterReservations = this.reservations.filter(function (reservation) {
                var arrival = moment(reservation.arrival.date);
                var departure = moment(reservation.departure.date);

                return arrival <= date && departure >= date;
            });

            return filterReservations.length > 0 ? filterReservations[0] : null;
        },
        isFirst: function isFirst(i, reservation) {
            if (!reservation) {
                return false;
            }

            var date = moment(this.date.format('YYYY-MM') + '-' + i, "YYYY-MM-DD");

            return date.isSame(moment(reservation.arrival.date));
        },
        isLast: function isLast(i, reservation) {
            if (!reservation) {
                return false;
            }

            var date = moment(this.date.format('YYYY-MM') + '-' + i, "YYYY-MM-DD");

            return date.isSame(moment(reservation.departure.date));
        },
        loadCleanings: function loadCleanings() {
            var _this2 = this;

            var options = {
                includes: ['user'],

                limit: 1,

                sort: [{
                    key: 'created',
                    direction: 'DESC'
                }],

                filter_groups: [{
                    filters: [{
                        key: 'room',
                        value: this.room.id,
                        operator: 'eq'
                    }]
                }]
            };

            CleaningService.findAll(options, function (response) {
                var data = response.data;

                if (data.total) {
                    _this2.cleaning = data.rows[0];
                }

                _this2.hasLoadedCleaning = true;
            });
        }
    }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        icon: {
            type: String
        },

        headline: {
            type: String
        },

        description: {
            type: String
        },

        close: {
            type: Boolean,
            default: false
        },

        center: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            visible: true
        };
    },

    methods: {
        remove: function remove() {
            this.visible = false;
        },
        hasHeader: function hasHeader() {
            return this.icon || this.headline || this.description;
        }
    }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            background: null
        };
    },
    mounted: function mounted() {
        eventHub.$on('background.set', this.set);
    },
    destroyed: function destroyed() {
        eventHub.$off('background.set', this.set);
    },


    methods: {
        set: function set(src) {
            this.background = src;
        }
    }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        inline: {
            type: Boolean,
            default: true
        }
    },

    methods: {
        print: function print() {
            window.print();
        }
    }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            classToLookFor: 'navigatable',
            activeClass: 'navigation-selected-active',
            activeElement: null
        };
    },
    mounted: function mounted() {
        this.selectFirstElement();

        window.addEventListener('keydown', this.checkKey);
    },
    destroyed: function destroyed() {
        window.removeEventListener('keydown', this.checkKey);
    },


    methods: {
        selectFirstElement: function selectFirstElement() {
            var elements = this.elements();

            if (!elements.length) {
                return;
            }

            this.select(elements[0]);
        },
        select: function select(element) {
            if (this.activeElement !== null) {
                this.activeElement.classList.remove(this.activeClass);
            }

            this.activeElement = element;
            this.activeElement.className += ' ' + this.activeClass;
        },
        elements: function elements() {
            return document.body.querySelectorAll('.' + this.classToLookFor);
        },
        checkKey: function checkKey(event) {
            var validKeys = [13, 37, 38, 39, 40];

            var keyCode = event.keyCode;

            if (validKeys.indexOf(keyCode) === -1) {
                return;
            }

            var direction = null;

            var tagName = document.activeElement.tagName.toLowerCase();

            switch (keyCode) {
                case 13:
                    if (tagName === 'textarea') {
                        return;
                    }

                    this.enter();
                    return;
                    break;

                case 37:
                    direction = 'left';
                    break;

                case 38:
                    direction = 'up';
                    break;

                case 39:
                    direction = 'right';
                    break;

                case 40:
                    direction = 'down';
                    break;
            }

            if (direction === 'up' || direction === 'down' && tagName !== 'textarea') {
                event.preventDefault();
            }

            if (this.activeElement) {
                if (tagName === 'input' || tagName === 'textarea') {
                    if (direction === 'left' || direction === 'right') {
                        var position = document.activeElement.selectionStart;
                        var characters = document.activeElement.value.length;

                        if (position !== 0 && direction === 'left' || position !== characters && direction === 'right') {
                            return;
                        }
                    }

                    document.activeElement.blur();
                }
            }

            return this.locateElement(direction);
        },
        locateElement: function locateElement(direction) {
            var _this = this;

            if (!this.activeElement) {
                return;
            }

            var current = this.position(this.activeElement);

            var filter = Array.prototype.filter;

            var potentialElements = filter.call(this.elements(), function (element) {
                var position = _this.position(element);

                switch (direction) {
                    case 'left':
                        return position.left < current.left;
                        break;

                    case 'up':
                        return position.top < current.top;
                        break;

                    case 'right':
                        return position.left > current.left;
                        break;

                    case 'down':
                        return position.top > current.top;
                        break;
                }
            });

            var selectedElement = null;
            var selectedDistance = 0;

            potentialElements.forEach(function (element) {
                var position = _this.position(element);

                var distance = _this.distance(element);

                if (direction === 'left' || direction === 'right') {
                    var diff = Math.abs(current.top - position.top);
                }

                if (direction === 'up' || direction === 'down') {
                    var _diff = Math.abs(current.left - position.left);
                }

                if (distance < 0) {
                    distance = distance * -1;
                }

                if (distance > selectedDistance && selectedElement !== null) {
                    return;
                }

                selectedElement = element;
                selectedDistance = distance;
            });

            if (!selectedElement) {
                return;
            }

            this.select(selectedElement);

            if (direction == 'up' || direction == 'down') {
                this.scrollToElement();
            }
        },


        /**
         * Get distance
         */
        distance: function distance(element) {
            if (!this.activeElement) {
                return 0;
            }

            var current = this.position(this.activeElement);

            var position = this.position(element);

            var distance = 0;

            distance += Math.abs(current.left - position.left);
            distance += Math.abs(current.top - position.top);

            return distance;
        },


        /**
         * Get position
         *
         * @param element
         * @returns {{left: number, top: number}}
         */
        position: function position(element) {
            return {
                left: element.getBoundingClientRect().left - window.scrollX,
                top: element.getBoundingClientRect().top - window.scrollY
            };
        },
        enter: function enter() {
            if (!this.activeElement) {
                return;
            }

            this.activeElement.click();
        },
        scrollToElement: function scrollToElement() {
            if (!this.activeElement) {
                return;
            }

            var bodyRect = document.body.getBoundingClientRect(),
                elemRect = this.activeElement.getBoundingClientRect(),
                offset = elemRect.top - bodyRect.top;

            document.body.scrollTop = offset - window.innerHeight * 0.4;
        }
    }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Card__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layout_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var MetaService = __webpack_require__(59);
var ReservationService = __webpack_require__(3);

var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        id: String
    },

    data: function data() {
        return {
            reservation: null,
            hasLoaded: false,
            meta: {}
        };
    },


    computed: {
        departure: function departure() {
            if (!this.reservation) {
                return;
            }

            var date = moment(this.reservation.departure.date);

            date.add(1, 'day');

            return date.format('ddd, MMM Do YYYY');
        },
        days: function days() {
            if (!this.reservation) {
                return 0;
            }

            var arrival = moment(this.reservation.arrival.date);
            var departure = moment(this.reservation.departure.date);

            return departure.diff(arrival, 'days') + 1;
        },
        total: function total() {
            var reservation = this.reservation;

            var total = 0;

            total += reservation.price;
            total += reservation.totalPriceBreakfast;
            total += reservation.totalProductPrice;

            return total;
        }
    },

    mounted: function mounted() {
        this.load();

        eventHub.$off('products.updated', this.load);
        eventHub.$off('reservation.updated', this.load);
    },
    destroyed: function destroyed() {
        eventHub.$on('products.updated', this.load);
        eventHub.$on('reservation.updated', this.load);
    },


    methods: {
        load: function load() {
            var _this = this;

            this.hasLoaded = false;
            this.reservation = null;

            var options = {
                includes: ['room']
            };

            ReservationService.find(this.id, options, function (response) {
                var data = response.data;

                _this.reservation = data;
                _this.hasLoaded = true;
            });

            MetaService.findAll({}, function (response) {
                var data = response.data;

                data.rows.forEach(function (meta) {
                    _this.$set(_this.meta, meta.field, meta.value);
                });
            });
        },
        update: function update() {
            var _this2 = this;

            this.hasLoaded = false;

            ReservationService.update(this.$route.params.id, this.reservation, function (response) {
                _this2.hasLoaded = true;
            });
        }
    },

    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0__components_layout_Card___default.a,
        Loader: __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader___default.a
    }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Card__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layout_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_reservations_Invoice__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_reservations_Invoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_reservations_Invoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_reservations_Products__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_reservations_Products___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_reservations_Products__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var ReservationService = __webpack_require__(3);
var TypeService = __webpack_require__(15);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            visible: false,
            reservation: null,
            hasLoaded: false,
            page: 'invoice',
            paid: false,

            types: [],
            selectedType: null
        };
    },


    watch: {
        $route: function $route() {
            this.visible = false;
        },
        visible: function visible() {
            this.page = 'invoice';

            if (!this.visible) {
                document.body.className = '';
                return;
            }

            document.body.className = 'locked';
        },
        selectedType: function selectedType() {
            if (this.selectedType.value === this.reservation.type.id) {
                return;
            }

            ReservationService.update(this.reservation.id, {
                type: this.selectedType.value
            });
        },
        types: function types() {
            if (!this.reservation) {
                return;
            }

            this.matchType();
        }
    },

    computed: {
        total: function total() {
            var reservation = this.reservation;

            if (!reservation) {
                return 0;
            }

            var total = 0;

            total += reservation.price;
            total += reservation.totalPriceBreakfast;
            total += reservation.totalProductPrice;

            return total;
        },
        typeOptions: function typeOptions() {
            return this.types.map(function (type) {
                return {
                    label: type.title,
                    value: type.id
                };
            });
        }
    },

    mounted: function mounted() {
        eventHub.$on('reservations.overlay', this.overlay);
        eventHub.$on('products.updated', this.navigateToInvoice);
    },
    destroyed: function destroyed() {
        eventHub.$off('reservations.overlay', this.overlay);
        eventHub.$off('products.updated', this.navigateToInvoice);
    },


    methods: {
        navigateToInvoice: function navigateToInvoice() {
            this.navigate('invoice');
        },
        overlay: function overlay(id) {
            this.visible = true;
            this.reservation = null;

            this.load(id);
        },
        load: function load(id) {
            var _this = this;

            this.reservation = null;
            this.hasLoaded = false;

            var options = {
                includes: ['type', 'room']
            };

            ReservationService.find(id, options, function (response) {
                _this.reservation = response.data;
                _this.hasLoaded = true;

                _this.paid = _this.reservation.paid;
                _this.loadTypes();
            });
        },
        hide: function hide() {
            this.visible = false;
        },
        navigate: function navigate(page) {
            this.page = page;
        },
        markPaid: function markPaid() {
            var _this2 = this;

            ReservationService.update(this.reservation.id, { paid: '1' }, function () {
                eventHub.$emit('reservation.updated', {
                    room: _this2.reservation.room.id
                });

                _this2.paid = true;
            });
        },
        markUnPaid: function markUnPaid() {
            var _this3 = this;

            ReservationService.update(this.reservation.id, { paid: '0' }, function () {
                eventHub.$emit('reservation.updated', {
                    room: _this3.reservation.room.id
                });

                _this3.paid = false;
            });
        },
        loadTypes: function loadTypes() {
            var _this4 = this;

            TypeService.findAll({}, function (response) {
                _this4.types = response.data.rows;
                _this4.hasLoaded = true;
            });
        },
        matchType: function matchType() {
            var _this5 = this;

            if (!this.reservation.type) {
                return;
            }

            var types = this.typeOptions.filter(function (type) {
                return type.value === _this5.reservation.type.id;
            });

            if (!types.length) {
                return;
            }

            this.selectedType = types[0];
        }
    },

    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0__components_layout_Card___default.a,
        Loader: __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader___default.a,
        Invoice: __WEBPACK_IMPORTED_MODULE_2__components_reservations_Invoice___default.a,
        Products: __WEBPACK_IMPORTED_MODULE_3__components_reservations_Products___default.a,
        Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a
    }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Card__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layout_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layout_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var ReservationService = __webpack_require__(3);
var ProductService = __webpack_require__(38);

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        id: String
    },

    data: function data() {
        return {
            reservation: null,
            hasLoaded: false,
            products: [],
            selected: null,
            chosenProducts: {}
        };
    },


    watch: {
        selected: function selected() {
            var _this = this;

            if (!this.selected) {
                return;
            }

            var product = this.selected.value;

            if (!this.chosenProducts[product.id]) {
                this.$set(this.chosenProducts, product.id, {
                    title: product.name,
                    quantity: 0,
                    price: product.price
                });
            }

            this.chosenProducts[product.id].quantity++;

            setTimeout(function () {
                _this.selected = null;
            }, 100);
        }
    },

    computed: {
        options: function options() {
            return this.products.map(function (product) {
                return {
                    label: product.name,
                    value: product
                };
            });
        }
    },

    mounted: function mounted() {
        this.load();
    },


    methods: {
        load: function load() {
            var _this2 = this;

            this.hasLoaded = false;
            this.chosenProducts = {};

            ProductService.findAll({
                sort: [{
                    key: 'name',
                    direction: 'ASC'
                }]
            }, function (response) {
                var data = response.data;

                _this2.products = data.rows;

                ReservationService.find(_this2.id, {}, function (response) {
                    _this2.reservation = response.data;
                    _this2.hasLoaded = true;

                    var products = _this2.reservation.products;

                    if (products.length === 0) {
                        _this2.chosenProducts = {};

                        return;
                    }

                    _this2.chosenProducts = products;
                });
            });
        },
        update: function update() {
            var _this3 = this;

            var products = {};

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.chosenProducts).forEach(function (id) {
                var product = _this3.chosenProducts[id];

                if (product.quantity <= 0) {
                    return;
                }

                products[id] = product;
            });

            this.hasLoaded = false;

            ReservationService.update(this.reservation.id, { products: products }, function () {
                _this3.load();

                eventHub.$emit('products.updated');
            });
        }
    },

    components: {
        Card: __WEBPACK_IMPORTED_MODULE_1__components_layout_Card___default.a,
        Loader: __WEBPACK_IMPORTED_MODULE_2__components_layout_Loader___default.a,
        Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a
    }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var RoomService = __webpack_require__(7);
var ReservationService = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        date: Object,
        types: Array
    },

    data: function data() {
        return {
            hasLoaded: false,
            availableRooms: {}
        };
    },


    watch: {
        date: function date() {
            this.load();
        }
    },

    mounted: function mounted() {
        this.load();
    },


    methods: {
        load: function load() {
            var _this = this;

            this.availableRooms = {};

            this.types.forEach(function (type) {
                var options = {
                    filter_groups: [{
                        filters: [{
                            key: 'type',
                            value: type.id,
                            operator: 'eq'
                        }]
                    }]
                };

                RoomService.findAll(options, function (response) {
                    var rooms = response.data;
                    var total = rooms.total;

                    ReservationService.findAll({
                        includes: ['room'],

                        filter_groups: [{
                            filters: [{
                                key: 'room.type',
                                value: type.id,
                                operator: 'eq'
                            }, {
                                key: 'belongsToDate',
                                value: _this.date.format('YYYY-MM-DD'),
                                operator: 'eq'
                            }]
                        }]
                    }, function (response) {
                        var reservations = response.data;

                        _this.$set(_this.availableRooms, type.id, rooms.total - reservations.total);
                    });
                });
            });

            this.hasLoaded = true;
        }
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader___default.a
    }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var ReservationService = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            query: null,
            timeout: null,
            delay: 500,
            searching: false,
            results: [],
            inverted: true,
            page: 1,
            showResults: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        document.onclick = function (event) {
            if (event.srcElement.getAttribute('data-action') === 'more-results') {
                return;
            }

            _this.showResults = false;
        };

        eventHub.$on('background.set', function (src) {
            _this.inverted = src === null;
        });

        if (this.$route && this.$route.params) {
            this.query = this.$route.params.query;
        }
    },
    destroyed: function destroyed() {
        var _this2 = this;

        eventHub.$off('background.set', function (src) {
            _this2.inverted = src === null;
        });
    },


    watch: {
        query: function query() {
            this.page = 1;
            this.searching = false;

            if (this.timeout) {
                clearTimeout(this.timeout);
            }

            if (!this.query || this.query.length < 3) {
                this.showResults = false;

                return;
            }

            this.timeout = setTimeout(this.search, this.delay);
        }
    },

    methods: {
        focus: function focus() {
            this.$el.querySelector('input').focus();
        },
        search: function search() {
            var _this3 = this;

            this.searching = true;

            var options = {
                limit: 8,
                page: this.page,

                includes: ['room'],

                sort: [{
                    key: 'arrival',
                    direction: 'DESC'
                }],

                filter_groups: [{
                    or: true,

                    filters: [{
                        key: 'name',
                        value: this.query,
                        operator: 'ct'
                    }, {
                        key: 'room.title',
                        value: this.query,
                        operator: 'ct'
                    }]
                }]
            };

            ReservationService.findAll(options, function (response) {
                var data = response.data;

                _this3.results = data.rows;
                _this3.showResults = true;
                _this3.searching = false;
            });
        },
        moreResults: function moreResults() {
            this.page++;

            this.search();
        }
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader___default.a
    }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(25);

//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
        identity: 'authGetIdentity'
    })),

    mounted: function mounted() {
        this.check();
    },


    watch: {
        $route: function $route() {
            this.check();
        }
    },

    methods: {
        check: function check() {
            var identity = this.identity;

            if (!identity) {
                this.$router.push({
                    name: 'login',
                    query: this.$router.currentRoute.query
                });
            }
        }
    }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layout_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Card__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layout_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var authConfig = __webpack_require__(265);
var AuthService = __webpack_require__(57);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            invalidLogin: false,
            email: null,
            password: null,
            hasLoaded: true
        };
    },
    mounted: function mounted() {
        this.lookForStoredIdentity();
    },


    watch: {
        email: function email() {
            this.invalidLogin = false;
        },
        password: function password() {
            if (!this.hasLoaded) {
                return;
            }

            this.invalidLogin = false;
        }
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
        setAccessToken: 'authSetAccessToken'
    }), {

        /**
         * Look for a stored identity
         */
        lookForStoredIdentity: function lookForStoredIdentity() {
            var _this = this;

            var token = this.$localStorage.get('token');

            if (!token) {
                return;
            }

            this.setAccessToken({
                token: token,
                cb: function cb() {
                    _this.$router.replace(_this.$route.query.redirect || '/reservations');
                }
            });
        },
        login: function login() {
            var _this2 = this;

            // Show loader
            this.hasLoaded = false;

            AuthService.login(this.email, this.password, function (response) {
                var body = response.data;
                var bearerToken = body.access_token;

                _this2.$localStorage.set('token', bearerToken);

                _this2.setAccessToken({
                    token: bearerToken,
                    cb: function cb() {
                        _this2.$router.replace(_this2.$route.query.redirect || '/reservations');
                    }
                });
            }, function () {
                _this2.invalidCredentials();

                setTimeout(function () {
                    _this2.hasLoaded = true;
                }, 200);
            });
        },
        invalidCredentials: function invalidCredentials() {
            this.invalidLogin = true;
            this.password = '';
        }
    }),

    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2__components_layout_Card___default.a
    }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_calendar_Room__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_calendar_Room___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_calendar_Room__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layout_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Print__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layout_Print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var ReservationService = __webpack_require__(3);
var moment = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            date: null,
            reservations: [],
            hasLoaded: false,
            loaded: 0
        };
    },


    computed: {
        eatingGuests: function eatingGuests() {
            var eatingGuests = 0;

            this.reservations.forEach(function (reservation) {
                eatingGuests += reservation.numberOfBreakfasts;
            });

            return eatingGuests;
        }
    },

    watch: {
        loaded: function loaded() {
            if (this.loaded !== this.rooms.length) {
                return;
            }

            this.hasLoaded = true;
        },
        date: function date() {
            this.load();
        }
    },

    mounted: function mounted() {
        this.setDefaultDate();
        this.load();
    },


    methods: {
        setDefaultDate: function setDefaultDate() {
            this.date = moment();
        },
        previous: function previous() {
            this.reset();

            this.date = moment(this.date.subtract(1, 'day'));
        },


        /**
         * Next
         **/
        next: function next() {
            this.reset();

            this.date = moment(this.date.add(1, 'day'));
        },
        reset: function reset() {
            this.loaded = 0;
            this.hasLoaded = false;
        },
        load: function load() {
            var _this = this;

            this.hasLoaded = false;

            var date = moment(this.date);
            date = date.subtract(1, 'day');

            var options = {
                sort: [{
                    key: 'room.order',
                    direction: 'ASC'
                }],

                includes: ['room'],

                filter_groups: [{
                    filters: [{
                        key: 'belongsToDate',
                        value: date.format('YYYY-MM-DD'),
                        operator: 'eq'
                    }, {
                        key: 'numberOfBreakfasts',
                        value: '0',
                        operator: 'gt'
                    }]
                }]
            };

            ReservationService.findAll(options, function (response) {
                var data = response.data;

                _this.reservations = data.rows;
                _this.hasLoaded = true;
            });
        }
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader___default.a,
        Room: __WEBPACK_IMPORTED_MODULE_0__components_calendar_Room___default.a,
        DatePicker: __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker___default.a,
        Print: __WEBPACK_IMPORTED_MODULE_2__components_layout_Print___default.a
    }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_calendar_Room__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_calendar_Room___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_calendar_Room__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layout_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Print__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layout_Print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var ReservationService = __webpack_require__(3);
var CleaningService = __webpack_require__(58);



var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            date: null,
            reservations: [],
            hasLoaded: false,
            loaded: 0,
            cleanings: [],
            hasLoadedCleanings: false
        };
    },


    computed: {
        isToday: function isToday() {
            var today = new moment();

            var date = moment(this.date);

            return today.format('DD/MM/YYYY') === date.format('DD/MM/YYYY');
        }
    },

    watch: {
        loaded: function loaded() {
            if (this.loaded !== this.rooms.length) {
                return;
            }

            this.hasLoaded = true;
        },
        date: function date() {
            this.load();
        }
    },

    mounted: function mounted() {
        this.load();
        this.setDefaultDate();
        this.loadCleanings();
    },


    methods: {
        setDefaultDate: function setDefaultDate() {
            this.date = moment();
        },
        previous: function previous() {
            this.reset();

            this.date = moment(this.date.subtract(1, 'day'));
        },


        /**
         * Next
         **/
        next: function next() {
            this.reset();

            this.date = moment(this.date.add(1, 'day'));
        },
        reset: function reset() {
            this.loaded = 0;
            this.hasLoaded = false;
        },
        load: function load() {
            var _this = this;

            if (!this.date) {
                return;
            }

            this.hasLoaded = false;

            var date = moment(this.date);
            date = date.subtract(1, 'day');

            var options = {
                sort: [{
                    key: 'room.order',
                    direction: 'ASC'
                }],

                includes: ['room'],

                filter_groups: [{
                    filters: [{
                        key: 'belongsToDate',
                        value: date.format('YYYY-MM-DD'),
                        operator: 'eq'
                    }]
                }]
            };

            ReservationService.findAll(options, function (response) {
                var data = response.data;

                _this.reservations = data.rows;
                _this.hasLoaded = true;
            });
        },
        isLeaving: function isLeaving(reservation) {
            var date = moment(this.date);

            date.subtract(1, 'day');

            return moment(reservation.departure.date).format('YYYY-MM-DD') === date.format('YYYY-MM-DD');
        },
        loadCleanings: function loadCleanings() {
            var _this2 = this;

            this.hasLoadedCleanings = false;

            var options = {
                includes: ['room'],

                sort: [{
                    key: 'created',
                    direction: 'DESC'
                }],

                filter_groups: [{
                    filters: [{
                        key: 'created',
                        value: this.date.format('YYYY-MM-DD'),
                        operator: 'gte'
                    }]
                }]
            };

            CleaningService.findAll(options, function (response) {
                var data = response.data;

                _this2.cleanings = data.rows;
                _this2.hasLoadedCleanings = true;
            });
        },
        hasBeenCleaned: function hasBeenCleaned(room) {
            var matchingCleanings = this.cleanings.filter(function (cleaning) {
                return cleaning.room.id === room.id;
            });

            return matchingCleanings.length > 0;
        },
        markCleaned: function markCleaned(room) {
            var _this3 = this;

            this.hasLoadedCleanings = false;

            CleaningService.create({ room: room.id }, function () {
                _this3.loadCleanings();
            });
        },
        openReservation: function openReservation(id) {
            this.$router.push({
                name: 'reservations.view',
                params: {
                    id: id
                }
            });
        }
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader___default.a,
        Room: __WEBPACK_IMPORTED_MODULE_0__components_calendar_Room___default.a,
        DatePicker: __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker___default.a,
        Print: __WEBPACK_IMPORTED_MODULE_2__components_layout_Print___default.a
    }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var ProductService = __webpack_require__(38);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            products: [],
            hasLoaded: false
        };
    },
    mounted: function mounted() {
        this.load();
    },


    methods: {
        load: function load() {
            var _this = this;

            ProductService.findAll({
                sort: [{
                    key: 'name',
                    direction: 'ASC'
                }]
            }, function (response) {
                var data = response.data;

                _this.products = data.rows;
                _this.hasLoaded = true;
            });
        }
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader___default.a
    }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var ProductService = __webpack_require__(38);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            product: null,
            hasLoaded: false
        };
    },
    mounted: function mounted() {
        this.load();
    },


    methods: {
        load: function load() {
            var _this = this;

            ProductService.find(this.$route.params.id, {}, function (response) {
                var data = response.data;

                _this.product = data;
                _this.hasLoaded = true;
            });
        },
        update: function update() {
            var _this2 = this;

            this.hasLoaded = false;

            ProductService.update(this.$route.params.id, this.product, function (response) {
                _this2.hasLoaded = true;
            });
        }
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader___default.a
    }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_calendar_Room__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_calendar_Room___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_calendar_Room__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layout_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Print__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layout_Print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var moment = __webpack_require__(0);



var RoomService = __webpack_require__(7);
var ReservationService = __webpack_require__(3);
var TypeService = __webpack_require__(15);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            hasLoaded: false,
            date: null,
            rooms: [],
            types: [],
            turnovers: {},
            turnoverTypes: {},
            total: 0
        };
    },


    watch: {
        date: function date() {
            this.load();
        }
    },

    mounted: function mounted() {
        this.setDefaultDate();
    },


    methods: {
        setDefaultDate: function setDefaultDate() {
            this.date = moment();
        },
        load: function load() {
            var _this = this;

            this.hasLoaded = false;
            this.rooms = [];
            this.types = [];
            this.turnovers = {};
            this.turnoverTypes = {};
            this.total = 0;

            RoomService.findAll({
                sort: [{
                    key: 'title',
                    direction: 'ASC'
                }]
            }, function (response) {
                var data = response.data;

                _this.rooms = data.rows;
            });

            TypeService.findAll({
                sort: [{
                    key: 'title',
                    direction: 'ASC'
                }]
            }, function (response) {
                var data = response.data;

                _this.types = data.rows;
            });

            var options = {
                includes: ['room', 'type'],

                filter_groups: [{
                    filters: [{
                        key: 'arrivalBelongsToDate',
                        value: this.date.format('YYYY-MM-DD'),
                        operator: 'ct'
                    }]
                }]
            };

            ReservationService.findAll(options, function (response) {
                var data = response.data;

                data.rows.forEach(function (reservation) {
                    var total = reservation.price + reservation.totalPriceBreakfast + reservation.totalProductPrice;

                    var room = reservation.room;

                    var turnover = _this.turnovers[room.id] ? _this.turnovers[room.id] : 0;

                    turnover += total;

                    _this.$set(_this.turnovers, room.id, turnover);

                    if (reservation.type) {
                        // Turnover types

                        var type = reservation.type;

                        var turnoverType = _this.turnoverTypes[type.id] ? _this.turnoverTypes[type.id] : 0;

                        turnoverType += total;

                        _this.$set(_this.turnoverTypes, type.id, turnoverType);
                    }

                    // Total

                    _this.total += total;
                });

                _this.hasLoaded = true;
            });
        }
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader___default.a,
        Room: __WEBPACK_IMPORTED_MODULE_0__components_calendar_Room___default.a,
        DatePicker: __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker___default.a,
        Print: __WEBPACK_IMPORTED_MODULE_2__components_layout_Print___default.a
    }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_calendar_Room__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_calendar_Room___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_calendar_Room__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layout_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Print__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layout_Print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var moment = __webpack_require__(0);



var RoomService = __webpack_require__(7);
var ReservationService = __webpack_require__(3);
var TypeService = __webpack_require__(15);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            hasLoaded: false,
            date: null,
            rooms: [],
            types: [],
            turnovers: {},
            turnoverTypes: {},
            total: 0
        };
    },


    watch: {
        date: function date() {
            this.load();
        }
    },

    mounted: function mounted() {
        this.setDefaultDate();
    },


    methods: {
        setDefaultDate: function setDefaultDate() {
            this.date = moment();
        },
        load: function load() {
            var _this = this;

            this.hasLoaded = false;
            this.rooms = [];
            this.types = [];
            this.turnovers = {};
            this.turnoverTypes = {};
            this.total = 0;

            RoomService.findAll({
                sort: [{
                    key: 'title',
                    direction: 'ASC'
                }]
            }, function (response) {
                var data = response.data;

                _this.rooms = data.rows;
            });

            TypeService.findAll({
                sort: [{
                    key: 'title',
                    direction: 'ASC'
                }]
            }, function (response) {
                var data = response.data;

                _this.types = data.rows;
            });

            var options = {
                includes: ['room', 'type'],

                filter_groups: [{
                    filters: [{
                        key: 'arrivalBelongsToMonth',
                        value: this.date.format('YYYY-MM'),
                        operator: 'ct'
                    }]
                }]
            };

            ReservationService.findAll(options, function (response) {
                var data = response.data;

                data.rows.forEach(function (reservation) {
                    var total = reservation.price + reservation.totalPriceBreakfast + reservation.totalProductPrice;

                    var room = reservation.room;

                    var turnover = _this.turnovers[room.id] ? _this.turnovers[room.id] : 0;

                    turnover += total;

                    _this.$set(_this.turnovers, room.id, turnover);

                    if (reservation.type) {
                        // Turnover types

                        var type = reservation.type;

                        var turnoverType = _this.turnoverTypes[type.id] ? _this.turnoverTypes[type.id] : 0;

                        turnoverType += total;

                        _this.$set(_this.turnoverTypes, type.id, turnoverType);
                    }

                    // Total

                    _this.total += total;
                });

                _this.hasLoaded = true;
            });
        }
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader___default.a,
        Room: __WEBPACK_IMPORTED_MODULE_0__components_calendar_Room___default.a,
        DatePicker: __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker___default.a,
        Print: __WEBPACK_IMPORTED_MODULE_2__components_layout_Print___default.a
    }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var RoomService = __webpack_require__(7);
var ReservationService = __webpack_require__(3);
var TypeService = __webpack_require__(15);

var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            hasLoaded: false,
            doubleBooking: false,

            rooms: [],
            selectedRoom: null,

            types: [],
            selectedType: null,

            arrival: moment(),
            departure: moment(),

            reservation: {
                name: null,
                comment: null,
                pricePerNight: 0,
                price: 0,
                room: null,
                guests: 0
            }
        };
    },


    watch: {
        selectedRoom: function selectedRoom() {
            var _this = this;

            this.$set(this.reservation, 'room', this.selectedRoom.value);

            var rooms = this.rooms.filter(function (room) {
                return room.id === _this.selectedRoom.value;
            });

            if (rooms.length) {
                this.$set(this.reservation, 'guests', rooms[0].type.guests);
            }
        },
        selectedType: function selectedType() {
            this.$set(this.reservation, 'type', this.selectedType.value);
        },
        arrival: function arrival() {
            this.updatePriceTotal();
        },
        departure: function departure() {
            this.updatePriceTotal();
        }
    },

    computed: {
        roomOptions: function roomOptions() {
            return this.rooms.map(function (room) {
                return {
                    label: room.title,
                    value: room.id
                };
            });
        },
        typeOptions: function typeOptions() {
            return this.types.map(function (type) {
                return {
                    label: type.title,
                    value: type.id
                };
            });
        },
        nights: function nights() {
            var nights = moment(this.departure).diff(moment(this.arrival), 'days');

            if (isNaN(nights)) {
                return 1;
            }

            return nights + 1;
        }
    },

    mounted: function mounted() {
        this.loadRooms();
    },


    methods: {
        loadRooms: function loadRooms() {
            var _this2 = this;

            var options = {
                includes: ['type'],

                sort: [{
                    key: 'title',
                    direction: 'ASC'
                }]
            };

            RoomService.findAll(options, function (response) {
                var data = response.data;

                _this2.rooms = data.rows;

                TypeService.findAll({}, function (response) {
                    _this2.types = response.data.rows;
                    _this2.hasLoaded = true;
                });
            });
        },
        create: function create() {
            var _this3 = this;

            this.doubleBooking = false;

            var reservation = this.reservation;

            if (!reservation.name || !reservation.type || !reservation.room || !reservation.price || !this.arrival || !this.departure) {
                return;
            }

            reservation.arrival = this.arrival.format('YYYY-MM-DD');
            reservation.departure = this.departure.format('YYYY-MM-DD');

            ReservationService.create(reservation, function (response) {
                var data = response.data;

                _this3.$router.push({
                    name: 'reservations.view',
                    params: {
                        id: data.id
                    }
                });
            }, function (response) {
                _this3.doubleBooking = true;
            });
        },
        updatePriceNight: function updatePriceNight() {
            this.$set(this.reservation, 'pricePerNight', this.reservation.price / this.nights);
        },
        updatePriceTotal: function updatePriceTotal() {
            this.$set(this.reservation, 'price', this.reservation.pricePerNight * this.nights);
        }
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader___default.a,
        DatePicker: __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker___default.a,
        Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a
    }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_reservations_Invoice__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_reservations_Invoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_reservations_Invoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Print__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layout_Print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_reservations_ReservationService__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            numberOfInvoices: null,
            loaded: 0,
            reservations: []
        };
    },


    computed: {
        hasLoaded: function hasLoaded() {
            return this.loaded === this.numberOfInvoices;
        },
        totalAmount: function totalAmount() {
            var total = 0;

            this.reservations.forEach(function (reservation) {
                total += reservation.price;
                total += reservation.totalPriceBreakfast;
                total += reservation.totalProductPrice;
            });

            return total;
        }
    },

    mounted: function mounted() {
        this.load();
    },


    methods: {
        load: function load() {
            var _this = this;

            var ids = this.$router.currentRoute.query.ids.split(',');
            this.numberOfInvoices = ids.length;

            ids.forEach(function (id) {
                __WEBPACK_IMPORTED_MODULE_3__services_reservations_ReservationService__["find"](id, {}, function (response) {
                    var reservation = response.data;

                    _this.reservations.push(reservation);
                    _this.loaded++;
                });
            });
        }
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader___default.a,
        Invoice: __WEBPACK_IMPORTED_MODULE_1__components_reservations_Invoice___default.a,
        Print: __WEBPACK_IMPORTED_MODULE_2__components_layout_Print___default.a
    }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_calendar_HeaderBlock__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_calendar_HeaderBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_calendar_HeaderBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_calendar_Room__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_calendar_Room___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_calendar_Room__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_layout_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_datetimepicker__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_datetimepicker__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var RoomService = __webpack_require__(7);
var moment = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            date: null,
            rooms: [],
            hasLoaded: false,
            loaded: 0,
            isGroupedInvoice: false,
            groupedReservations: {}
        };
    },


    watch: {
        loaded: function loaded() {
            if (this.loaded !== this.rooms.length) {
                return;
            }

            this.hasLoaded = true;
        }
    },

    mounted: function mounted() {
        this.subscribe();
        this.load();
        this.setDefaultDate();
    },
    destroyed: function destroyed() {
        this.unsubscribe();
    },


    methods: {
        setDefaultDate: function setDefaultDate() {
            this.date = moment();
        },
        previous: function previous() {
            this.reset();

            this.date = moment(this.date.subtract(1, 'month'));
        },


        /**
         * Next
         **/
        next: function next() {
            this.reset();

            this.date = moment(this.date.add(1, 'month'));
        },
        reset: function reset() {
            this.hasLoaded = false;
            this.loaded = 0;
        },
        load: function load() {
            var _this = this;

            RoomService.findAll({
                sort: [{
                    key: 'order',
                    direction: 'ASC'
                }]
            }, function (response) {
                var data = response.data;

                _this.rooms = data.rows;
            });
        },
        subscribe: function subscribe() {
            var channel = this.$pusher.subscribe('cleanings');

            channel.bind('room.cleaned', function (payload) {
                eventHub.$emit('room.cleaned', { room: payload.room });
            });
        },
        unsubscribe: function unsubscribe() {
            this.$pusher.unsubscribe('cleanings');
        },
        groupInvoice: function groupInvoice() {
            this.isGroupedInvoice = !this.isGroupedInvoice;

            if (this.isGroupedInvoice) {
                return;
            }

            if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.groupedReservations).length) {
                return;
            }

            this.$router.push({
                name: 'reservations.grouped',
                query: {
                    ids: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.groupedReservations).join(',')
                }
            });
        },
        group: function group(reservation) {
            if (this.groupedReservations[reservation.id]) {
                // remove
                this.$delete(this.groupedReservations, reservation.id);
                return;
            }

            this.$set(this.groupedReservations, reservation.id, reservation);
        }
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_3__components_layout_Loader___default.a,
        HeaderBlock: __WEBPACK_IMPORTED_MODULE_1__components_calendar_HeaderBlock___default.a,
        Room: __WEBPACK_IMPORTED_MODULE_2__components_calendar_Room___default.a,
        DatePicker: __WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_datetimepicker___default.a
    }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Card__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layout_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layout_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_reservations_Invoice__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_reservations_Invoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_reservations_Invoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_reservations_Products__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_reservations_Products___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_reservations_Products__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bootstrap_datetimepicker__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_bootstrap_datetimepicker__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var ReservationService = __webpack_require__(3);
var TypeService = __webpack_require__(15);
var RoomService = __webpack_require__(7);

var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            reservation: null,
            room: null,
            hasLoaded: false,
            doubleBooking: false,

            types: [],
            selectedType: null,

            rooms: [],
            selectedRoom: null
        };
    },


    watch: {
        selectedType: function selectedType() {
            this.$set(this.reservation, 'type', this.selectedType.value);
        },
        types: function types() {
            if (!this.reservation) {
                return;
            }

            this.matchType();
        },
        selectedRoom: function selectedRoom() {
            this.$set(this.reservation, 'room', this.selectedRoom.value);
        },
        rooms: function rooms() {
            if (!this.reservation) {
                return;
            }

            this.matchRoom();
        },
        reservation: function reservation() {
            if (!this.types.length) {
                return;
            }

            this.matchType();
        }
    },

    computed: {
        typeOptions: function typeOptions() {
            return this.types.map(function (type) {
                return {
                    label: type.title,
                    value: type.id
                };
            });
        },
        roomOptions: function roomOptions() {
            return this.rooms.map(function (room) {
                return {
                    label: room.title,
                    value: room.id
                };
            });
        }
    },

    mounted: function mounted() {
        this.load();
        this.loadTypes();
        this.loadRooms();
    },


    methods: {
        load: function load() {
            var _this = this;

            var options = {
                includes: ['room', 'type']
            };

            ReservationService.find(this.$route.params.id, options, function (response) {
                var data = response.data;

                _this.reservation = data;
                _this.hasLoaded = true;
            });
        },
        update: function update() {
            var _this2 = this;

            this.hasLoaded = false;
            this.doubleBooking = false;

            var options = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.reservation));

            options.arrival = moment(options.arrival.date).format('YYYY-MM-DD');
            options.departure = moment(options.departure.date).format('YYYY-MM-DD');

            ReservationService.update(this.$route.params.id, options, function (response) {
                _this2.hasLoaded = true;
            }, function (response) {
                _this2.hasLoaded = true;
                _this2.doubleBooking = true;
            });
        },
        print: function print() {
            window.print();
        },
        remove: function remove() {
            var _this3 = this;

            this.$swal({
                type: 'warning',
                title: 'Are you sure?',
                description: 'This action is permanent',
                showCancelButton: true
            }).then(function () {
                ReservationService.remove(_this3.reservation.id);

                _this3.$swal('Success', 'The reservation has been deleted', 'success');

                setTimeout(function () {
                    _this3.$router.push({
                        name: 'reservations'
                    });
                }, 600);
            });
        },
        loadTypes: function loadTypes() {
            var _this4 = this;

            TypeService.findAll({}, function (response) {
                _this4.types = response.data.rows;
                _this4.hasLoaded = true;
            });
        },
        matchType: function matchType() {
            var _this5 = this;

            if (!this.reservation.type) {
                return;
            }

            var types = this.typeOptions.filter(function (type) {
                return type.value === _this5.reservation.type.id;
            });

            if (!types.length) {
                return;
            }

            this.selectedType = types[0];
        },
        loadRooms: function loadRooms() {
            var _this6 = this;

            RoomService.findAll({}, function (response) {
                _this6.rooms = response.data.rows;
                _this6.hasLoaded = true;
            });
        },
        matchRoom: function matchRoom() {
            var _this7 = this;

            if (!this.reservation.room) {
                return;
            }

            var rooms = this.roomOptions.filter(function (room) {
                return room.value === _this7.reservation.room.id;
            });

            if (!rooms.length) {
                return;
            }

            this.selectedRoom = rooms[0];
        }
    },

    components: {
        Card: __WEBPACK_IMPORTED_MODULE_1__components_layout_Card___default.a,
        Loader: __WEBPACK_IMPORTED_MODULE_2__components_layout_Loader___default.a,
        Invoice: __WEBPACK_IMPORTED_MODULE_3__components_reservations_Invoice___default.a,
        Products: __WEBPACK_IMPORTED_MODULE_4__components_reservations_Products___default.a,
        DatePicker: __WEBPACK_IMPORTED_MODULE_6_vue_bootstrap_datetimepicker___default.a,
        Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a
    }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Print__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout_Print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_rooms_AvailableRooms__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_rooms_AvailableRooms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_rooms_AvailableRooms__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__(0);




var TypeService = __webpack_require__(267);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            date: null,
            types: []
        };
    },


    computed: {
        days: function days() {
            return this.date.daysInMonth();
        }
    },

    mounted: function mounted() {
        this.setDefaultDate();
        this.loadTypes();
    },


    methods: {
        setDefaultDate: function setDefaultDate() {
            this.date = moment();
        },
        dayOfMonth: function dayOfMonth(offset) {
            offset--;

            var date = moment(this.date);
            date.startOf('month');

            date.add(offset, 'days');

            return date;
        },
        loadTypes: function loadTypes() {
            var _this = this;

            TypeService.findAll({
                sort: [{
                    key: 'title',
                    direction: 'ASC'
                }]
            }, function (response) {
                var data = response.data;

                _this.types = data.rows;
            });
        }
    },

    components: {
        DatePicker: __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker___default.a,
        Print: __WEBPACK_IMPORTED_MODULE_0__components_layout_Print___default.a,
        AvailableRooms: __WEBPACK_IMPORTED_MODULE_2__components_rooms_AvailableRooms___default.a
    }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var RoomService = __webpack_require__(7);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            rooms: [],
            hasLoaded: false
        };
    },
    mounted: function mounted() {
        this.load();
    },


    methods: {
        load: function load() {
            var _this = this;

            RoomService.findAll({
                sort: [{
                    key: 'order',
                    direction: 'ASC'
                }]
            }, function (response) {
                var data = response.data;

                _this.rooms = data.rows;
                _this.hasLoaded = true;
            });
        }
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader___default.a
    }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var RoomService = __webpack_require__(7);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            room: null,
            hasLoaded: false
        };
    },
    mounted: function mounted() {
        this.load();
    },


    methods: {
        load: function load() {
            var _this = this;

            RoomService.find(this.$route.params.id, {}, function (response) {
                var data = response.data;

                _this.room = data;
                _this.hasLoaded = true;
            });
        },
        update: function update() {
            var _this2 = this;

            this.hasLoaded = false;

            RoomService.update(this.$route.params.id, this.room, function (response) {
                _this2.hasLoaded = true;
            });
        }
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_0__components_layout_Loader___default.a
    }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layout_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(25);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var MetaService = __webpack_require__(59);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            hasLoaded: false,
            meta: [],
            updates: {}
        };
    },


    computed: {
        sortedMeta: function sortedMeta() {
            return this.meta.sort(function (a, b) {
                return a.order - b.order;
            });
        }
    },

    mounted: function mounted() {
        this.load();
    },


    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
        signOut: 'authSignOut'
    }), {
        load: function load() {
            var _this = this;

            this.hasLoaded = false;
            this.updates = {};

            MetaService.findAll({}, function (response) {
                var data = response.data;

                _this.meta = data.rows;

                _this.meta.forEach(function (property) {
                    _this.updates[property.field] = property.value;
                });

                _this.hasLoaded = true;
            });
        },
        addUpdate: function addUpdate(event) {
            if (!this.hasLoaded) {
                return;
            }

            var element = event.srcElement;
            var field = element.getAttribute('data-field');
            var value = element.value;

            this.$set(this.updates, field, value);
        },
        update: function update() {
            var _this2 = this;

            this.hasLoaded = false;

            var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.updates);

            keys.forEach(function (key) {
                MetaService.update(key, { value: _this2.updates[key] });
            });

            setTimeout(function () {
                _this2.load();
            }, 400);
        }
    }),

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_2__components_layout_Loader___default.a
    }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_calendar_Room__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_calendar_Room___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_calendar_Room__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layout_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Print__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layout_Print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var moment = __webpack_require__(0);



var RoomService = __webpack_require__(7);
var ReservationService = __webpack_require__(3);
var TypeService = __webpack_require__(15);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            hasLoaded: false,
            date: null,
            guests: 0,
            guestNights: 0,
            roomNights: 0
        };
    },


    watch: {
        date: function date() {
            this.load();
        }
    },

    mounted: function mounted() {
        this.setDefaultDate();
    },


    methods: {
        setDefaultDate: function setDefaultDate() {
            this.date = moment();
        },
        load: function load() {
            var _this = this;

            this.hasLoaded = false;

            var options = {
                includes: ['room', 'type'],

                filter_groups: [{
                    filters: [{
                        key: 'arrivalBelongsToMonth',
                        value: this.date.format('YYYY-MM'),
                        operator: 'ct'
                    }]
                }]
            };

            ReservationService.findAll(options, function (response) {
                var data = response.data;

                var startOfMonth = moment(_this.date).startOf('month');
                var endOfMonth = moment(_this.date).endOf('month');

                data.rows.forEach(function (reservation) {
                    var arrival = new moment(reservation.arrival.date).startOf('day');
                    var departure = new moment(reservation.departure.date).startOf('day');

                    if (arrival < startOfMonth) {
                        arrival = startOfMonth;
                    }

                    if (departure > endOfMonth) {
                        departure = endOfMonth;
                    }

                    _this.roomNights += departure.diff(arrival, 'days');
                    _this.guests += reservation.guests;
                    _this.guestNights += reservation.guests * departure.diff(arrival, 'days');
                });

                _this.hasLoaded = true;
            });
        }
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_1__components_layout_Loader___default.a,
        Room: __WEBPACK_IMPORTED_MODULE_0__components_calendar_Room___default.a,
        DatePicker: __WEBPACK_IMPORTED_MODULE_3_vue_bootstrap_datetimepicker___default.a,
        Print: __WEBPACK_IMPORTED_MODULE_2__components_layout_Print___default.a
    }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "url", function() { return url; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scope", function() { return scope; });


var url = 'login';
var scope = '';

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_localstorage__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__deveodk_vue_toastr__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__deveodk_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__deveodk_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__deveodk_vue_toastr_dist_deveodk_vue_toastr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_tooltip__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_sweetalert__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_highcharts__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_api__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(36);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].router = __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

window.eventHub = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]();

// Localstorage



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_localstorage___default.a);

// Moment

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__webpack_require__(214));

// Filters
__webpack_require__(206);

// Pusher
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__webpack_require__(215), {
    api_key: '5292704ba3fca37f9b11',
    authEndpoint: '/pusher_auth.php',
    options: {
        cluster: 'eu',
        encrypted: true
    }
});

// Toastr



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__deveodk_vue_toastr___default.a, {
    defaultPosition: 'toast-top-right',
    defaultType: 'info',
    defaultTimeout: 10000
});

// Tooltip


__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_v_tooltip__["a" /* default */]);

// Sweet alert


__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_sweetalert___default.a);

// Highcharts



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_highcharts__["a" /* default */]);

// Axios

var axios = __webpack_require__(204);



var VueAxios = axios.create({
    baseURL: 'https://city-api.ahotels.dk',
    withCredentials: true,
    paramsSerializer: function paramsSerializer(params) {
        return toQueryString(params);$;
    }
});

function toQueryString(object, prefix) {
    var string = [],
        key = void 0,
        value = void 0;

    for (var property in object) {
        if (!object.hasOwnProperty(property)) {
            continue;
        }

        key = prefix ? prefix + "[" + property + "]" : property;

        if (~property.indexOf('[')) {
            key = prefix ? prefix + "[" + property.substring(0, property.indexOf('[')) + "]" + property.substring(property.indexOf('[')) : property;
        }

        value = object[property];
        string.push((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) == "object" ? toQueryString(value, key) : encodeURIComponent(key) + "=" + encodeURIComponent(value));
    }

    return string.join("&");
}

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$http = VueAxios;

// Video

var VueVideoPlayer = __webpack_require__(217);

// mount with global
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(VueVideoPlayer);

// Vuex


/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "find", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findAll", function() { return findAll; });
var BaseService = __webpack_require__(6);

var namespace = 'rooms/types';

var find = function find(id, options, cb) {
  BaseService.get(namespace + '/' + id, options, cb);
};

var findAll = function findAll(options, cb) {
  BaseService.get(namespace, options, cb);
};



/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "find", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findAll", function() { return findAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return identity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remove", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "password", function() { return password; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "put", function() { return put; });
var BaseService = __webpack_require__(6);

var namespace = 'users';

var find = function find(id, options, cb) {
  BaseService.get(namespace + '/' + id, options, cb);
};

var findAll = function findAll(options, cb) {
  BaseService.get(namespace, options, cb);
};

var identity = function identity(options, cb, errorCb) {
  BaseService.get(namespace + '/identity', options, cb, errorCb);
};

var remove = function remove(id, cb) {
  BaseService.remove(namespace + '/' + id, cb);
};

var put = function put(id, data, cb, errorCb) {
  BaseService.put(namespace + '/' + id, data, cb, errorCb);
};

var password = function password(_password, cb, errorCb) {
  BaseService.put(namespace + '/password', { password: _password }, cb, errorCb);
};



/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mutation_types__);


/***/ }),
/* 270 */
/***/ (function(module, exports) {



/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(202);



var AuthService = __webpack_require__(57);
var UserService = __webpack_require__(268);

var state = {
    identity: null,
    token: null
};

var getters = {
    authGetIdentity: function authGetIdentity(state) {
        return state.identity;
    },
    authHasIdentity: function authHasIdentity(state) {
        return state.identity !== null;
    }
};

var mutations = {
    authSetIdentity: function authSetIdentity(state, identity) {
        state.identity = identity;
    },
    authSetToken: function authSetToken(state, token) {
        state.token = token;
    }
};

var actions = {
    /**
     * Set access token
     *
     * @param commit
     * @param dispatch
     * @param payload
     */
    authSetAccessToken: function authSetAccessToken(_ref, payload) {
        var commit = _ref.commit,
            dispatch = _ref.dispatch;

        var token = payload.token;

        var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

        // Set header
        vm.$http.defaults.headers.common.Authorization = 'Bearer ' + token;

        commit('authSetToken', token);

        dispatch('authLoadIdentity', payload);
    },


    /**
     * Load identity
     *
     * @param commit
     * @param dispatch
     * @param payload
     */
    authLoadIdentity: function authLoadIdentity(_ref2, payload) {
        var commit = _ref2.commit,
            dispatch = _ref2.dispatch;

        var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

        UserService.identity({}, function (response) {
            if (response.status !== 200) {
                return false;
            }

            var identity = response.data;

            commit('authSetIdentity', response.data);

            if (payload.cb !== undefined) {
                payload.cb();
            }
        }, function () {
            dispatch('authSignOut');
        });
    },


    /**
     * Sign out
     *
     * @param context
     * @param cb
     */
    authSignOut: function authSignOut(context, cb) {
        var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

        vm.$localStorage.remove('token');

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].router.push({
            name: 'login'
        });
    },


    /**
     * Refresh token
     *
     * @param dispatch
     * @param payload
     */
    authRefreshToken: function authRefreshToken(_ref3, payload) {
        var dispatch = _ref3.dispatch;

        var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

        // vm.$http.defaults.headers.common.Authorization = null

        // Forget token
        vm.$http.post('login/refresh').then(function (response) {
            var body = response.data;
            var token = body.access_token;

            // Set header
            vm.$http.defaults.headers.common.Authorization = 'Bearer ' + token;

            vm.$localStorage.set('token', token);

            if (payload && payload.cb) {
                payload.cb();
            }
        }).catch(function (error) {
            // dispatch('authSignOut')
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 272 */
/***/ (function(module, exports) {



/***/ }),
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 72,
	"./af.js": 72,
	"./ar": 79,
	"./ar-dz": 73,
	"./ar-dz.js": 73,
	"./ar-kw": 74,
	"./ar-kw.js": 74,
	"./ar-ly": 75,
	"./ar-ly.js": 75,
	"./ar-ma": 76,
	"./ar-ma.js": 76,
	"./ar-sa": 77,
	"./ar-sa.js": 77,
	"./ar-tn": 78,
	"./ar-tn.js": 78,
	"./ar.js": 79,
	"./az": 80,
	"./az.js": 80,
	"./be": 81,
	"./be.js": 81,
	"./bg": 82,
	"./bg.js": 82,
	"./bm": 83,
	"./bm.js": 83,
	"./bn": 84,
	"./bn.js": 84,
	"./bo": 85,
	"./bo.js": 85,
	"./br": 86,
	"./br.js": 86,
	"./bs": 87,
	"./bs.js": 87,
	"./ca": 88,
	"./ca.js": 88,
	"./cs": 89,
	"./cs.js": 89,
	"./cv": 90,
	"./cv.js": 90,
	"./cy": 91,
	"./cy.js": 91,
	"./da": 92,
	"./da.js": 92,
	"./de": 95,
	"./de-at": 93,
	"./de-at.js": 93,
	"./de-ch": 94,
	"./de-ch.js": 94,
	"./de.js": 95,
	"./dv": 96,
	"./dv.js": 96,
	"./el": 97,
	"./el.js": 97,
	"./en-SG": 98,
	"./en-SG.js": 98,
	"./en-au": 99,
	"./en-au.js": 99,
	"./en-ca": 100,
	"./en-ca.js": 100,
	"./en-gb": 101,
	"./en-gb.js": 101,
	"./en-ie": 102,
	"./en-ie.js": 102,
	"./en-il": 103,
	"./en-il.js": 103,
	"./en-nz": 104,
	"./en-nz.js": 104,
	"./eo": 105,
	"./eo.js": 105,
	"./es": 108,
	"./es-do": 106,
	"./es-do.js": 106,
	"./es-us": 107,
	"./es-us.js": 107,
	"./es.js": 108,
	"./et": 109,
	"./et.js": 109,
	"./eu": 110,
	"./eu.js": 110,
	"./fa": 111,
	"./fa.js": 111,
	"./fi": 112,
	"./fi.js": 112,
	"./fo": 113,
	"./fo.js": 113,
	"./fr": 116,
	"./fr-ca": 114,
	"./fr-ca.js": 114,
	"./fr-ch": 115,
	"./fr-ch.js": 115,
	"./fr.js": 116,
	"./fy": 117,
	"./fy.js": 117,
	"./ga": 118,
	"./ga.js": 118,
	"./gd": 119,
	"./gd.js": 119,
	"./gl": 120,
	"./gl.js": 120,
	"./gom-latn": 121,
	"./gom-latn.js": 121,
	"./gu": 122,
	"./gu.js": 122,
	"./he": 123,
	"./he.js": 123,
	"./hi": 124,
	"./hi.js": 124,
	"./hr": 125,
	"./hr.js": 125,
	"./hu": 126,
	"./hu.js": 126,
	"./hy-am": 127,
	"./hy-am.js": 127,
	"./id": 128,
	"./id.js": 128,
	"./is": 129,
	"./is.js": 129,
	"./it": 131,
	"./it-ch": 130,
	"./it-ch.js": 130,
	"./it.js": 131,
	"./ja": 132,
	"./ja.js": 132,
	"./jv": 133,
	"./jv.js": 133,
	"./ka": 134,
	"./ka.js": 134,
	"./kk": 135,
	"./kk.js": 135,
	"./km": 136,
	"./km.js": 136,
	"./kn": 137,
	"./kn.js": 137,
	"./ko": 138,
	"./ko.js": 138,
	"./ku": 139,
	"./ku.js": 139,
	"./ky": 140,
	"./ky.js": 140,
	"./lb": 141,
	"./lb.js": 141,
	"./lo": 142,
	"./lo.js": 142,
	"./lt": 143,
	"./lt.js": 143,
	"./lv": 144,
	"./lv.js": 144,
	"./me": 145,
	"./me.js": 145,
	"./mi": 146,
	"./mi.js": 146,
	"./mk": 147,
	"./mk.js": 147,
	"./ml": 148,
	"./ml.js": 148,
	"./mn": 149,
	"./mn.js": 149,
	"./mr": 150,
	"./mr.js": 150,
	"./ms": 152,
	"./ms-my": 151,
	"./ms-my.js": 151,
	"./ms.js": 152,
	"./mt": 153,
	"./mt.js": 153,
	"./my": 154,
	"./my.js": 154,
	"./nb": 155,
	"./nb.js": 155,
	"./ne": 156,
	"./ne.js": 156,
	"./nl": 158,
	"./nl-be": 157,
	"./nl-be.js": 157,
	"./nl.js": 158,
	"./nn": 159,
	"./nn.js": 159,
	"./pa-in": 160,
	"./pa-in.js": 160,
	"./pl": 161,
	"./pl.js": 161,
	"./pt": 163,
	"./pt-br": 162,
	"./pt-br.js": 162,
	"./pt.js": 163,
	"./ro": 164,
	"./ro.js": 164,
	"./ru": 165,
	"./ru.js": 165,
	"./sd": 166,
	"./sd.js": 166,
	"./se": 167,
	"./se.js": 167,
	"./si": 168,
	"./si.js": 168,
	"./sk": 169,
	"./sk.js": 169,
	"./sl": 170,
	"./sl.js": 170,
	"./sq": 171,
	"./sq.js": 171,
	"./sr": 173,
	"./sr-cyrl": 172,
	"./sr-cyrl.js": 172,
	"./sr.js": 173,
	"./ss": 174,
	"./ss.js": 174,
	"./sv": 175,
	"./sv.js": 175,
	"./sw": 176,
	"./sw.js": 176,
	"./ta": 177,
	"./ta.js": 177,
	"./te": 178,
	"./te.js": 178,
	"./tet": 179,
	"./tet.js": 179,
	"./tg": 180,
	"./tg.js": 180,
	"./th": 181,
	"./th.js": 181,
	"./tl-ph": 182,
	"./tl-ph.js": 182,
	"./tlh": 183,
	"./tlh.js": 183,
	"./tr": 184,
	"./tr.js": 184,
	"./tzl": 185,
	"./tzl.js": 185,
	"./tzm": 187,
	"./tzm-latn": 186,
	"./tzm-latn.js": 186,
	"./tzm.js": 187,
	"./ug-cn": 188,
	"./ug-cn.js": 188,
	"./uk": 189,
	"./uk.js": 189,
	"./ur": 190,
	"./ur.js": 190,
	"./uz": 192,
	"./uz-latn": 191,
	"./uz-latn.js": 191,
	"./uz.js": 192,
	"./vi": 193,
	"./vi.js": 193,
	"./x-pseudo": 194,
	"./x-pseudo.js": 194,
	"./yo": 195,
	"./yo.js": 195,
	"./zh-cn": 196,
	"./zh-cn.js": 196,
	"./zh-hk": 197,
	"./zh-hk.js": 197,
	"./zh-tw": 198,
	"./zh-tw.js": 198
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 341;

/***/ }),
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(386),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(324)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(395),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-54e3a1a4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(325)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(398),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-667af1b3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(397),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(317)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(387),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-28684e67",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(320)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(391),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c6800e5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(318)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(388),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-28f54580",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(389),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(328)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(401),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-74003e77",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(333)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(406),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9b9ef66c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(330)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(403),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7afea92a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(323)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(394),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4d65c18a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(381),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(334)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(407),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c7e2ec32",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(326)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(399),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6bebc130",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(396),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(408),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(332)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(405),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8a9ab42c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(384),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(336)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(410),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fffd9966",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(327)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(400),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6d3aac08",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(383),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(319)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(390),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-38e9f86a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(316)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(385),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1acf5bea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoice"
  }, [(!_vm.hasLoaded) ? _c('loader') : [_c('div', {
    staticClass: "header"
  }, [(_vm.reservation.paid) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticClass: "paid"
  }, [_vm._v("Paid")])]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.meta.name))]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                " + _vm._s(_vm.meta.address) + "\n            ")])]), _vm._v(" "), _c('table', {
    staticClass: "table visible-print"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Billing")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.meta.billing))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Stay")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.reservation.name))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "roomName"
  }, [_vm._v(_vm._s(_vm.reservation.room.title))]), _c('br')]), _vm._v(" "), _c('td', [_c('small', {
    staticClass: "grey"
  }, [_vm._v("Arrival")]), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.reservation.arrival.date, "ddd, MMM Do YYYY"))), _c('br'), _vm._v("14:00")]), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "grey"
  }, [_vm._v("Departure")]), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.departure)), _c('br'), _vm._v("11:00")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Invoice ID")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.reservation.readableId) + "\n                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Date issued")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm._f("moment")(_vm.reservation.arrival.date, "MMM DD, YYYY")) + "\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "info hidden-print"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-7 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-4 col-sm-4"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                Billing\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-8 col-sm-8"
  }, [_c('span', {
    staticClass: "billing"
  }, [_vm._v(_vm._s(_vm.meta.billing))]), _c('br')])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-4 col-sm-4"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                Stay\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-8 col-sm-8"
  }, [_c('span', [_vm._v(_vm._s(_vm.reservation.name))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "roomName"
  }, [_vm._v(_vm._s(_vm.reservation.room.title))]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "arrival-departure"
  }, [_c('div', [_c('small', {
    staticClass: "grey"
  }, [_vm._v("arrival")]), _vm._v(" "), _c('small', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.reservation.arrival.date, "ddd, MMM Do YYYY"))), _c('br'), _vm._v("14:00")])]), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "grey"
  }, [_vm._v("departure")]), _vm._v(" "), _c('small', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.departure)), _c('br'), _vm._v("11:00")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-5 hidden-sm hidden-xs text-right right"
  }, [_c('div', [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                            Invoice ID\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.reservation.readableId))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                            Date issued\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.reservation.arrival.date, "MMM DD, YYYY")))])])]), _vm._v(" "), _c('div', {
    staticClass: "visible-xs visible-sm"
  }, [_c('div', [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                            Invoice ID\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.reservation.id))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                            Date issued\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.reservation.arrival.date, "MMM DD, YYYY")))])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table invoice-lines"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("Product")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2 text-right"
  }, [_vm._v("Unit price")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3 text-right"
  }, [_vm._v("Total")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(_vm.reservation.room.title)), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Room")])]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.days) + "  "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("night(s)")])]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.reservation.price / _vm.days, 2))) + "\n                    ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.reservation.price, 2))) + "\n                        ")])])]), _vm._v(" "), _vm._l((_vm.reservation.products), function(product) {
    return _c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(product.title)), _c('br'), _vm._v(" "), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v("Product")])]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(product.quantity) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(product.price, 2))) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('span', {
      staticClass: "text-muted"
    }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(product.price * product.quantity, 2))) + "\n                        ")])])])
  }), _vm._v(" "), (_vm.reservation.numberOfBreakfasts > 0) ? _c('tr', [_c('td', [_vm._v("\n                        Breakfast"), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Product")])]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.reservation.numberOfBreakfasts) + "  "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("person(s)")])]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.reservation.totalPriceBreakfast / _vm.reservation.numberOfBreakfasts, 2))) + "\n                    ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.reservation.totalPriceBreakfast, 2))) + "\n                    ")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "total"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._v("\n                    Subtotal (excl. tax)\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.total * 0.8, 2))) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._v("\n                    Tax\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.total * 0.20, 2))) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('strong', [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.total, 2))))])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "appreciate-your-business"
  }, [_vm._v("\n            We appreciate the confidence you have placed in us and we look forward to providing you with the best possible service in the future.\n        ")])]], 2)
},staticRenderFns: []}

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product"
  }, [(!_vm.hasLoaded) ? _c('loader') : [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n                " + _vm._s(_vm.product.name) + "\n\n                "), _c('small', [_vm._v("\n                     \n                    "), _c('button', {
    staticClass: "btn btn-danger btn-fill btn-sm"
  }, [_c('span', {
    staticClass: "fa fa-remove fa-fw"
  }), _vm._v("\n                        Remove\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-lg-offset-2 col-md-8 col-md-offset-1 col-sm-12"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.name),
      expression: "product.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Price")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.price),
      expression: "product.price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "price", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-4 col-sm-8"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("Update product")])])])])])])]], 2)
},staticRenderFns: []}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "products"
  }, [(!_vm.hasLoaded) ? _c('loader') : [_c('multiselect', {
    attrs: {
      "placeholder": "Add a new product",
      "track-by": "label",
      "label": "label",
      "options": _vm.options,
      "close-on-select": true,
      "show-labels": false
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, [_vm._l((_vm.chosenProducts), function(product) {
    return _c('div', {
      key: product.id,
      staticClass: "list-group-item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (product.quantity),
        expression: "product.quantity"
      }],
      staticClass: "form-control pull-right quantity",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (product.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(product, "quantity", $event.target.value)
        }
      }
    }), _vm._v("\n\n                " + _vm._s(product.title)), _c('br'), _vm._v(" "), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v("\n                    DKK " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(product.price, 2))) + "\n                ")])])
  }), _vm._v(" "), (Object.keys(_vm.chosenProducts).length === 0) ? _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n                No products\n            ")]) : _vm._e()], 2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": _vm.update
    }
  }, [_vm._v("Save")])]], 2)
},staticRenderFns: []}

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product"
  }, [(!_vm.hasLoaded) ? _c('loader') : [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n                " + _vm._s(_vm.room.title) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-lg-offset-2 col-md-8 col-md-offset-1 col-sm-12"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.room.title),
      expression: "room.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.room.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.room, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.room.description),
      expression: "room.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.room.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.room, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-4 col-sm-8"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("Update room")])])])])])])]], 2)
},staticRenderFns: []}

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reservation"
  }, [(!_vm.hasLoaded) ? _c('loader') : [_c('div', {
    staticClass: "hidden-print"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n                    " + _vm._s(_vm.reservation.name) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-7 col-sm-6"
  }, [_c('invoice', {
    attrs: {
      "id": _vm.reservation.id
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-5 col-sm-6"
  }, [_c('card', [_c('div', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Reservation")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.name),
      expression: "reservation.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Type",
      "track-by": "label",
      "label": "label",
      "options": _vm.typeOptions,
      "close-on-select": true,
      "show-labels": false
    },
    model: {
      value: (_vm.selectedType),
      callback: function($$v) {
        _vm.selectedType = $$v
      },
      expression: "selectedType"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Room")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Room",
      "track-by": "label",
      "label": "label",
      "options": _vm.roomOptions,
      "close-on-select": true,
      "show-labels": false
    },
    model: {
      value: (_vm.selectedRoom),
      callback: function($$v) {
        _vm.selectedRoom = $$v
      },
      expression: "selectedRoom"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.comment),
      expression: "reservation.comment"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.reservation.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "comment", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.doubleBooking
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Arrival")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'YYYY-MM-DD'
      }
    },
    model: {
      value: (_vm.reservation.arrival.date),
      callback: function($$v) {
        _vm.$set(_vm.reservation.arrival, "date", $$v)
      },
      expression: "reservation.arrival.date"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.doubleBooking
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Departure")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'YYYY-MM-DD'
      }
    },
    model: {
      value: (_vm.reservation.departure.date),
      callback: function($$v) {
        _vm.$set(_vm.reservation.departure, "date", $$v)
      },
      expression: "reservation.departure.date"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Number of guests")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.guests),
      expression: "reservation.guests"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.guests)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "guests", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Breakfast")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('small', [_vm._v("Eating guests")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.numberOfBreakfasts),
      expression: "reservation.numberOfBreakfasts"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.numberOfBreakfasts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "numberOfBreakfasts", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('small', [_vm._v("Total for all nights")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.totalPriceBreakfast),
      expression: "reservation.totalPriceBreakfast"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.totalPriceBreakfast)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "totalPriceBreakfast", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-4 col-sm-8"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("Update reservation")])])])])]), _vm._v(" "), _c('card', [_c('div', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Invoice")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.print
    }
  }, [_vm._v("Print")])])]), _vm._v(" "), _c('card', [_c('div', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Products")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('products', {
    attrs: {
      "id": _vm.reservation.id
    }
  })], 1), _vm._v(" "), _c('card', [_c('div', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Delete reservation")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Delete this reservation")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "visible-print"
  }, [_c('invoice', {
    attrs: {
      "id": _vm.reservation.id
    }
  })], 1)]], 2)
},staticRenderFns: []}

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.date !== null) ? _c('div', [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n            Statistics \n\n            "), _c('small', [_vm._v("\n                " + _vm._s(_vm._f("moment")(_vm.date, "MMMM \'YY")) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'MMMM YYYY'
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('print'), _vm._v(" \n            ")], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.hasLoaded) ? _c('loader') : [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Personankomster")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                                    " + _vm._s(_vm.guests) + " personankomster\n                                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Gæstenætter")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                                    " + _vm._s(_vm.guestNights) + " gæstenætter\n                                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Værelsesnætter")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                                    " + _vm._s(_vm.roomNights) + " værelsesnætter\n                                ")])])])])])])]], 2)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-player"
  }, [_c('video', {
    staticClass: "video-js"
  })])
}]}

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "reservation"
  }, [_c('div', {
    staticClass: "background",
    on: {
      "click": _vm.hide
    }
  }), _vm._v(" "), (!_vm.hasLoaded) ? _c('loader') : _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [(_vm.page == 'invoice') ? _c('invoice', {
    attrs: {
      "id": _vm.reservation.id
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page == 'products') ? _c('card', [(_vm.page == 'products') ? _c('products', {
    attrs: {
      "id": _vm.reservation.id
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('card', [_c('strong', [_vm._v("Total cost")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.total, 2))) + "\n\n                    "), (_vm.reservation.room) ? [_c('hr'), _vm._v(" "), _c('strong', [_vm._v("Room")]), _c('br'), _vm._v("\n                        " + _vm._s(_vm.reservation.room.title) + "\n                    ")] : _vm._e(), _vm._v(" "), (_vm.reservation.type) ? [_c('hr'), _vm._v(" "), _c('strong', [_vm._v("Payment")]), _c('br'), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": "Type",
      "track-by": "label",
      "label": "label",
      "options": _vm.typeOptions,
      "close-on-select": true,
      "show-labels": false
    },
    model: {
      value: (_vm.selectedType),
      callback: function($$v) {
        _vm.selectedType = $$v
      },
      expression: "selectedType"
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, [_c('router-link', {
    staticClass: "list-group-item",
    attrs: {
      "to": {
        name: 'reservations.view',
        params: {
          id: _vm.reservation.id
        }
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-pencil fa-fw"
  }), _vm._v("  \n                        Edit reservation\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "list-group-item",
    on: {
      "click": function($event) {
        return _vm.navigate('products')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-shopping-cart fa-fw"
  }), _vm._v("  \n                        Edit products\n                    ")]), _vm._v(" "), (!_vm.paid) ? _c('button', {
    staticClass: "list-group-item",
    on: {
      "click": _vm.markPaid
    }
  }, [_c('span', {
    staticClass: "fa fa-credit-card fa-fw"
  }), _vm._v("  \n                        Mark as paid\n                    ")]) : _c('button', {
    staticClass: "list-group-item",
    on: {
      "click": _vm.markUnPaid
    }
  }, [_c('span', {
    staticClass: "fa fa-ban fa-fw text-danger"
  }), _vm._v("  \n                        Mark as unpaid\n                    ")])], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search navigatable",
    class: {
      inverted: _vm.inverted
    },
    on: {
      "click": _vm.focus
    }
  }, [_c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.searching) ? _c('span', {
    staticClass: "fa fa-spin fa-spinner",
    on: {
      "click": _vm.focus
    }
  }) : _c('span', {
    staticClass: "fa fa-search fa-fw",
    on: {
      "click": _vm.focus
    }
  })]), _vm._v(" "), (_vm.showResults && _vm.results.length) ? _c('div', {
    staticClass: "results list-group",
    class: {
      searching: _vm.searching
    }
  }, [(_vm.searching) ? _c('div', {
    staticClass: "loader-container"
  }, [_c('loader')], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.results), function(reservation) {
    return _c('router-link', {
      key: reservation.id,
      staticClass: "list-group-item result navigatable",
      attrs: {
        "to": {
          name: 'reservations.view',
          params: {
            id: reservation.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "pull-right muted"
    }, [_c('i', [_vm._v(_vm._s(reservation.room.title))])]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(reservation.name))]), _c('br'), _vm._v(" "), _c('small', [_vm._v("\n                    " + _vm._s(_vm._f("moment")(reservation.arrival.date, "DD/MM")) + " \n                    "), _c('span', {
      staticClass: "fa fa-long-arrow-right fa-fw"
    }), _vm._v("\n                    " + _vm._s(_vm._f("moment")(reservation.departure.date, "DD/MM/YY")) + "\n                ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [(_vm.results.length === 8) ? _c('div', {
    staticClass: "list-group-item navigatable text-center",
    attrs: {
      "data-action": "more-results"
    },
    on: {
      "click": _vm.moreResults
    }
  }, [_c('span', {
    attrs: {
      "data-action": "more-results"
    }
  }, [_vm._v("More results")])]) : _vm._e()])], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rooms"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.hasLoaded) ? _c('loader') : _c('div', {
    staticClass: "col-lg-6 col-lg-offset-2 col-md-8 col-md-offset-1 col-sm-12"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_vm._l((_vm.sortedMeta), function(property) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-4 control-label"
    }, [_vm._v(_vm._s(property.label))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8"
    }, [(property.type === null || property.type === 'text') ? _c('input', {
      staticClass: "form-control",
      attrs: {
        "data-field": property.field,
        "type": "text"
      },
      domProps: {
        "value": property.value
      },
      on: {
        "keyup": _vm.addUpdate
      }
    }) : (property.type === 'textarea') ? _c('textarea', {
      staticClass: "form-control",
      attrs: {
        "data-field": property.field
      },
      domProps: {
        "value": property.value
      },
      on: {
        "keyup": _vm.addUpdate
      }
    }) : _vm._e()])])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-4 col-sm-8"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("Update information")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Click here to sign out")])])], 2)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n            Settings\n        ")])])
}]}

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "availableRooms"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-lg-offset-4 col-md-6 col-md-offset-3 col-sm-12"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.date, "dddd D. MMMM YYYY")))])]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.hasLoaded) ? _c('loader') : _c('table', {
    staticClass: "table"
  }, [_c('tbody', _vm._l((_vm.types), function(type) {
    return _c('tr', {
      key: type.id
    }, [_c('td', {
      staticClass: "col-md-6"
    }, [_vm._v("\n                            " + _vm._s(type.title) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "col-md-6 text-right"
    }, [(_vm.availableRooms[type.id] !== undefined) ? [_vm._v("\n                                " + _vm._s(_vm.availableRooms[type.id]) + " room(s)\n                            ")] : _vm._e()], 2)])
  }), 0)])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "room"
  }, [_c('div', {
    staticClass: "roomTitle"
  }, [_vm._v("\n        " + _vm._s(_vm.room.title) + "\n\n        "), (_vm.currentMonth && _vm.isClean !== null) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-center",
      value: (_vm.cleaningStatus),
      expression: "cleaningStatus",
      modifiers: {
        "top-center": true
      }
    }],
    staticClass: "fa fa-info-circle fa-fw pull-right status",
    class: {
      cleaned: _vm.isClean
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "days"
  }, _vm._l((_vm.daysInMonth), function(i) {
    return _c('div', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ((_vm.matchedReservations[i]) ? _vm.matchedReservations[i].name : null),
        expression: "(matchedReservations[i]) ? matchedReservations[i].name : null"
      }],
      staticClass: "navigatable",
      class: {
        today: _vm.currentMonth && i === _vm.today.day(),
          reserved: _vm.matchedReservations[i] !== null && _vm.matchedReservations[i] !== undefined,
          first: _vm.isFirst(i, _vm.matchedReservations[i]),
          last: _vm.isLast(i, _vm.matchedReservations[i]), isPaid: (_vm.matchedReservations[i] && _vm.matchedReservations[i].paid),
          grouped: (_vm.matchedReservations[i] && _vm.groupedReservations[_vm.matchedReservations[i].id])
      },
      on: {
        "click": function($event) {
          return _vm.select(i)
        }
      }
    }, [(i < 10) ? [_vm._v("0")] : _vm._e(), _vm._v(_vm._s(i) + "\n        ")], 2)
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.layout) ? [_c('div', {
    staticClass: "containers"
  }, [_c('div', {
    staticClass: "left-block hidden-xs hidden-print"
  }, [_c('div', [_c('ul', {
    staticClass: "nav"
  }, [_c('li', [_c('router-link', {
    staticClass: "navigatable",
    attrs: {
      "to": {
        name: 'reservations'
      },
      "exact": ""
    }
  }, [_c('div', [_c('span', {
    staticClass: "icon pe-7s-date"
  }), _vm._v(" "), _c('span', [_vm._v("Overview")])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "navigatable",
    attrs: {
      "to": {
        name: 'breakfasts'
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "icon pe-7s-wine"
  }), _vm._v(" "), _c('span', [_vm._v("Breakfasts")])])])], 1), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    staticClass: "navigatable",
    attrs: {
      "to": {
        name: 'rooms.available'
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "icon pe-7s-unlock"
  }), _vm._v(" "), _c('span', [_vm._v("Available rooms")])])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "navigatable",
    attrs: {
      "to": {
        name: 'cleaning'
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "icon pe-7s-door-lock"
  }), _vm._v(" "), _c('span', [_vm._v("Cleaning")])])])], 1), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    staticClass: "navigatable",
    attrs: {
      "to": {
        name: 'reporting'
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "icon pe-7s-graph"
  }), _vm._v(" "), _c('span', [_vm._v("Reporting")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    staticClass: "navigatable",
    attrs: {
      "to": {
        name: 'statistics'
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "icon pe-7s-graph3"
  }), _vm._v(" "), _c('span', [_vm._v("Danmarks Statistik")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    staticClass: "navigatable",
    attrs: {
      "to": {
        name: 'products'
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "icon pe-7s-cart"
  }), _vm._v(" "), _c('span', [_vm._v("Products")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    staticClass: "navigatable",
    attrs: {
      "to": {
        name: 'rooms'
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "icon pe-7s-home"
  }), _vm._v(" "), _c('span', [_vm._v("Rooms")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    staticClass: "navigatable",
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "icon pe-7s-tools"
  }), _vm._v(" "), _c('span', [_vm._v("Settings")])])])], 1) : _c('li', [_c('a', {
    staticClass: "navigatable",
    on: {
      "click": _vm.signOut
    }
  }, [_vm._m(0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-block"
  }, [_c('router-view')], 1), _vm._v(" "), _c('reservation-overlay')], 1), _vm._v(" "), _c('div', {
    staticClass: "search-container hidden-print visible-lg visible-md"
  }, [_c('search')], 1)] : _c('router-view'), _vm._v(" "), _c('key-navigation')], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "icon pe-7s-tools"
  }), _vm._v(" "), _c('span', [_vm._v("Sign out")])])
}]}

/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rooms"
  }, [_vm._m(0), _vm._v(" "), (!_vm.hasLoaded) ? _c('loader') : _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.products), function(product) {
    return _c('router-link', {
      key: product.id,
      staticClass: "list-group-item navigatable",
      attrs: {
        "to": {
          name: 'products.view',
          params: {
            id: product.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "pe-7s-angle-right-circle pull-right action"
    }), _vm._v("\n\n            " + _vm._s(product.name)), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(product.price) + ",- DKK")])])
  }), 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n            Products\n\n            "), _c('small', [_c('button', {
    staticClass: "btn btn-default btn-fill btn-sm"
  }, [_c('span', {
    staticClass: "fa fa-plus fa-fw"
  }), _vm._v("\n                    Add new\n                ")])])])])
}]}

/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "headerTitle"
  }), _vm._v(" "), _c('div', {
    staticClass: "days"
  }, _vm._l((_vm.daysInMonth), function(i) {
    return _c('div', [_c('strong', {
      class: {
        isToday: _vm.isToday(i)
      }
    }, [_vm._v("\n                " + _vm._s(_vm.day(i)) + "\n            ")])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reservation"
  }, [(!_vm.hasLoaded) ? _c('loader') : [_c('div', {
    staticClass: "hidden-print"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n                    Create reservation\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-lg-offset-2 col-md-8 col-md-offset-1 col-sm-12"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Room")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Room",
      "track-by": "label",
      "label": "label",
      "options": _vm.roomOptions,
      "close-on-select": true,
      "show-labels": false
    },
    model: {
      value: (_vm.selectedRoom),
      callback: function($$v) {
        _vm.selectedRoom = $$v
      },
      expression: "selectedRoom"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Type",
      "track-by": "label",
      "label": "label",
      "options": _vm.typeOptions,
      "close-on-select": true,
      "show-labels": false
    },
    model: {
      value: (_vm.selectedType),
      callback: function($$v) {
        _vm.selectedType = $$v
      },
      expression: "selectedType"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.name),
      expression: "reservation.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.doubleBooking
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Arrival")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'YYYY-MM-DD'
      }
    },
    model: {
      value: (_vm.arrival),
      callback: function($$v) {
        _vm.arrival = $$v
      },
      expression: "arrival"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.doubleBooking
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Departure")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'YYYY-MM-DD'
      }
    },
    model: {
      value: (_vm.departure),
      callback: function($$v) {
        _vm.departure = $$v
      },
      expression: "departure"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Price")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('small', [_vm._v("Per night")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.pricePerNight),
      expression: "reservation.pricePerNight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.pricePerNight)
    },
    on: {
      "keyup": _vm.updatePriceTotal,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "pricePerNight", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('small', [_vm._v("Total")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.price),
      expression: "reservation.price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.price)
    },
    on: {
      "keyup": _vm.updatePriceNight,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "price", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Number of guests")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.guests),
      expression: "reservation.guests"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.guests)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "guests", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Breakfast")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('small', [_vm._v("Eating guests")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.numberOfBreakfasts),
      expression: "reservation.numberOfBreakfasts"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.numberOfBreakfasts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "numberOfBreakfasts", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('small', [_vm._v("Total for all nights")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.totalPriceBreakfast),
      expression: "reservation.totalPriceBreakfast"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.totalPriceBreakfast)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "totalPriceBreakfast", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.comment),
      expression: "reservation.comment"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.reservation.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "comment", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-4 col-sm-8"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("Create reservation")])])])])])])])]], 2)
},staticRenderFns: []}

/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.background !== null) ? _c('div', {
    staticClass: "page-background"
  }, [_c('img', {
    attrs: {
      "src": _vm.background
    }
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.date !== null) ? _c('div', {
    staticClass: "overview"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n            Reporting \n\n            "), _c('small', [_vm._v("\n                " + _vm._s(_vm._f("moment")(_vm.date, "MMMM \'YY")) + "\n            ")]), _vm._v(" "), _c('small', [_c('router-link', {
    staticClass: "btn btn-default btn-fill btn-sm",
    attrs: {
      "to": {
        name: 'reporting.daily'
      }
    }
  }, [_vm._v("Switch to daily")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'MMMM YYYY'
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('print'), _vm._v(" \n            ")], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.hasLoaded) ? _c('loader') : [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-xs-6"
  }, [_vm._v("\n                                Room\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "col-xs-6 text-right"
  }, [_vm._v("\n                                Turnover\n                            ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rooms), function(room) {
    return _c('tr', [_c('td', [_vm._v("\n                                    " + _vm._s(room.title) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(_vm.turnovers[room.id]) ? [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.turnovers[room.id], 2))) + "\n                                    ")] : _vm._e()], 2)])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-xs-6"
  }, [_vm._v("\n                                    Type\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "col-xs-6 text-right"
  }, [_vm._v("\n                                    Turnover\n                                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.types), function(type) {
    return _c('tr', [_c('td', [_vm._v("\n                                    " + _vm._s(type.title) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(_vm.turnoverTypes[type.id]) ? [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.turnoverTypes[type.id], 2))) + "\n                                    ")] : _vm._e()], 2)])
  }), 0)]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("\n                                    VAT\n                                ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.total * 0.20, 2))) + "\n                                ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('strong', [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.total, 2))))])])])])])])])]], 2)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rooms"
  }, [_vm._m(0), _vm._v(" "), (!_vm.hasLoaded) ? _c('loader') : _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.rooms), function(room) {
    return _c('router-link', {
      key: room.id,
      staticClass: "list-group-item navigatable",
      attrs: {
        "to": {
          name: 'rooms.view',
          params: {
            id: room.id
          }
        }
      }
    }, [_vm._v("\n            " + _vm._s(room.title) + "\n            "), _c('span', {
      staticClass: "pe-7s-angle-right-circle pull-right action"
    })])
  }), 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n            Rooms\n\n            "), _c('small', [_vm._v("\n                 \n                "), _c('button', {
    staticClass: "btn btn-default btn-fill btn-sm"
  }, [_c('span', {
    staticClass: "fa fa-plus fa-fw"
  }), _vm._v("\n                    Add new\n                ")])])])])
}]}

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "details hidden-xs hidden-sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-container"
  }, [_c('card', [_c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "lead"
  }, [_vm._v("hello.")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.invalidLogin) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('strong', [_vm._v("Invalid credentials")]), _vm._v(". Please try again\n                ")]) : _vm._e()]), _vm._v(" "), _c('form', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.invalidLogin
    }
  }, [_c('label', [_vm._v("E-mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.invalidLogin
    }
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Sign in")])])]), _vm._v(" "), _c('br')], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "print btn btn-primary hidden-print",
    class: {
      inline: _vm.inline
    },
    on: {
      "click": _vm.print
    }
  }, [_c('span', {
    staticClass: "fa fa-print fa-fw"
  }), _vm._v(" \n    Print\n")])
},staticRenderFns: []}

/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.date !== null) ? _c('div', {
    staticClass: "cleanings"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n            Cleaning\n\n            "), _c('small', {
    staticClass: "controls"
  }, [_vm._v("\n                " + _vm._s(_vm._f("moment")(_vm.date, 'DD MMMM \'YY')) + " \n\n                "), _c('span', {
    staticClass: "pe-7s-angle-left-circle navigatable",
    on: {
      "click": function($event) {
        return _vm.previous()
      }
    }
  }), _vm._v(" \n                "), _c('span', {
    staticClass: "pe-7s-angle-right-circle navigatable",
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-right hidden-print"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'DD MMMM YYYY'
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right hidden-print"
  }, [_c('print'), _vm._v(" \n            ")], 1)])]), _vm._v(" "), (!_vm.hasLoaded) ? _c('loader') : [_c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "lead"
  }, [_vm._v(_vm._s(_vm.reservations.length) + " cleaning(s)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, _vm._l((_vm.reservations), function(reservation) {
    return _c('div', {
      staticClass: "list-group-item"
    }, [(_vm.isToday && _vm.hasLoadedCleanings && !_vm.hasBeenCleaned(reservation.room)) ? _c('div', {
      staticClass: "action",
      on: {
        "click": function($event) {
          return _vm.markCleaned(reservation.room)
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("\n                        Mark as cleaned\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "status"
    }, [(_vm.isLeaving(reservation)) ? _c('span', {
      staticClass: "label label-danger text-uppercase"
    }, [_vm._v("\n                        Checkout\n                    ")]) : _c('span', {
      staticClass: "label label-warning text-uppercase"
    }, [_vm._v("\n                        Regular\n                    ")])]), _vm._v("\n\n                 \n\n                "), _c('div', {
      staticClass: "meta",
      on: {
        "click": function($event) {
          return _vm.openReservation(reservation.id)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(reservation.room.title)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(reservation.name))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), 0)]], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "card",
    class: {
      'center-content': _vm.center
    }
  }, [(_vm.hasHeader()) ? _c('div', {
    staticClass: "header",
    class: {
      'header-icon': _vm.icon != null
    }
  }, [(_vm.icon) ? _c('span', {
    staticClass: "icon",
    class: _vm.icon
  }) : _vm._e(), _vm._v(" "), (_vm.headline) ? _c('div', {
    staticClass: "headline pull-left",
    class: {
      oneHeadline: !_vm.description
    }
  }, [_vm._v("\n            " + _vm._s(_vm._f("capitalize")(_vm.headline)) + "\n\n            "), _vm._v(" "), (_vm.description) ? _c('p', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._t("header")], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "content",
    class: {
      'center-me': _vm.center
    }
  }, [_c('div', [_vm._t("default")], 2)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.date !== null) ? _c('div', {
    staticClass: "overview"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n            " + _vm._s(_vm._f("moment")(_vm.date, 'MMMM \'YY')) + " \n\n            "), _c('small', {
    staticClass: "controls"
  }, [_c('span', {
    staticClass: "pe-7s-angle-left-circle navigatable",
    on: {
      "click": function($event) {
        return _vm.previous()
      }
    }
  }), _vm._v(" \n                "), _c('span', {
    staticClass: "pe-7s-angle-right-circle navigatable",
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "hidden-print"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-fill btn-sm",
    attrs: {
      "to": {
        name: 'reservations.create'
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus fa-fw"
  }), _vm._v("\n                    Add new\n                ")])], 1), _vm._v(" "), (!_vm.isGroupedInvoice) ? _c('small', {
    staticClass: "hidden-print"
  }, [_c('button', {
    staticClass: "btn btn-default btn-fill btn-sm",
    on: {
      "click": _vm.groupInvoice
    }
  }, [_vm._v("\n                    Grouped invoice\n                ")])]) : _c('small', {
    staticClass: "hidden-print"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-fill btn-sm",
    on: {
      "click": _vm.groupInvoice
    }
  }, [_vm._v("\n                    Apply\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'MMMM YYYY'
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)])]), _vm._v(" "), (!_vm.hasLoaded) ? _c('loader') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "calendar"
  }, [_c('div', [(_vm.date && _vm.hasLoaded) ? _c('header-block', {
    attrs: {
      "date": _vm.date
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.rooms), function(room) {
    return _c('room', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hasLoaded),
        expression: "hasLoaded"
      }],
      key: room.id,
      attrs: {
        "room": room,
        "date": _vm.date,
        "groupedInvoice": _vm.isGroupedInvoice,
        "groupedReservations": _vm.groupedReservations
      },
      on: {
        "reservationsLoaded": function($event) {
          _vm.loaded++
        },
        "reservationsGroup": _vm.group
      }
    })
  })], 2)])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.date !== null) ? _c('div', {
    staticClass: "reservations"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n            Breakfasts\n\n            "), _c('small', {
    staticClass: "controls"
  }, [_vm._v("\n                " + _vm._s(_vm._f("moment")(_vm.date, 'DD MMMM \'YY')) + " \n\n                "), _c('span', {
    staticClass: "pe-7s-angle-left-circle navigatable",
    on: {
      "click": function($event) {
        return _vm.previous()
      }
    }
  }), _vm._v(" \n                "), _c('span', {
    staticClass: "pe-7s-angle-right-circle navigatable",
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-right hidden-print"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'DD MMMM YYYY'
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right hidden-print"
  }, [_c('print'), _vm._v(" \n            ")], 1)])]), _vm._v(" "), (!_vm.hasLoaded) ? _c('loader') : [_c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "lead"
  }, [_vm._v(_vm._s(_vm.reservations.length) + " room(s) / " + _vm._s(_vm.eatingGuests) + " guests")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, _vm._l((_vm.reservations), function(reservation) {
    return _c('router-link', {
      key: reservation.id,
      staticClass: "list-group-item",
      attrs: {
        "to": {
          name: 'reservations.view',
          params: {
            id: reservation.id
          }
        }
      }
    }, [_vm._v("\n                " + _vm._s(reservation.room.title)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "muted"
    }, [_vm._v(_vm._s(reservation.name))]), _vm._v(" / " + _vm._s(reservation.numberOfBreakfasts) + " guest(s)\n\n                "), _c('span', {
      staticClass: "pe-7s-angle-right-circle pull-right action hidden-print"
    })])
  }), 1)]], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.date !== null) ? _c('div', {
    staticClass: "overview"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n            Reporting \n\n            "), _c('small', [_vm._v("\n                " + _vm._s(_vm._f("moment")(_vm.date, "DD. MMMM \'YY")) + "\n            ")]), _vm._v(" "), _c('small', [_c('router-link', {
    staticClass: "btn btn-default btn-fill btn-sm",
    attrs: {
      "to": {
        name: 'reporting'
      }
    }
  }, [_vm._v("Switch to monthly")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'DD MMMM YYYY'
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('print'), _vm._v(" \n            ")], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.hasLoaded) ? _c('loader') : [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-xs-6"
  }, [_vm._v("\n                                Room\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "col-xs-6 text-right"
  }, [_vm._v("\n                                Turnover\n                            ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rooms), function(room) {
    return _c('tr', [_c('td', [_vm._v("\n                                    " + _vm._s(room.title) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(_vm.turnovers[room.id]) ? [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.turnovers[room.id], 2))) + "\n                                    ")] : _vm._e()], 2)])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-xs-6"
  }, [_vm._v("\n                                    Type\n                                ")]), _vm._v(" "), _c('th', {
    staticClass: "col-xs-6 text-right"
  }, [_vm._v("\n                                    Turnover\n                                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.types), function(type) {
    return _c('tr', [_c('td', [_vm._v("\n                                    " + _vm._s(type.title) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(_vm.turnoverTypes[type.id]) ? [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.turnoverTypes[type.id], 2))) + "\n                                    ")] : _vm._e()], 2)])
  }), 0)]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("\n                                    VAT\n                                ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.total * 0.20, 2))) + "\n                                ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('strong', [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.total, 2))))])])])])])])])]], 2)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grouped-invoice"
  }, [(!_vm.hasLoaded) ? _c('loader') : [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-lg-offset-3 col-sm-12"
  }, [_c('div', {
    staticClass: "pull-right hidden-print"
  }, [_c('print'), _vm._v(" \n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    staticClass: "lead text-center"
  }, [_vm._v("Summary")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Bookings")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                                        " + _vm._s(_vm.numberOfInvoices) + " bookings\n                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("VAT")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.totalAmount * 0.20, 2))) + ",- DKK\n                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Subtotal")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.totalAmount * 0.80, 2))) + ",- DKK\n                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.totalAmount, 2))) + ",- DKK\n                                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-lg-offset-3 col-sm-12"
  }, _vm._l((_vm.reservations), function(reservation) {
    return _c('div', {
      key: reservation.id
    }, [_c('invoice', {
      attrs: {
        "id": reservation.id
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)
  }), 0)])]], 2)
},staticRenderFns: []}

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "sk-cube-grid"
  }, [_c('div', {
    staticClass: "sk-cube sk-cube1"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube2"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube3"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube4"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube5"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube6"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube7"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube8"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube9"
  })])])
}]}

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.date !== null) ? _c('div', {
    staticClass: "overview"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n            Available rooms \n\n            "), _c('small', [_vm._v("\n                " + _vm._s(_vm._f("moment")(_vm.date, "MMMM \'YY")) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-xs"
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'MMMM YYYY'
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('print'), _vm._v(" \n            ")], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-xs"
  })])]), _vm._v(" "), _vm._l((_vm.days), function(n) {
    return (_vm.types.length) ? _c('available-rooms', {
      key: n,
      attrs: {
        "date": _vm.dayOfMonth(n),
        "types": _vm.types
      }
    }) : _vm._e()
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[266]);


// WEBPACK FOOTER //
// static/js/app.a3a964670c235e23c268.js